// // src/lang/LanguageContext.js
// import React, { createContext, useContext, useState, useEffect } from "react";

// // 1) Создаём контекст
// const LanguageContext = createContext();

// // 2) Провайдер, который хранит текущий язык и функцию его смены
// export function LanguageProvider({ children, defaultLang = "ru" }) {
//   const [lang, setLang] = useState(defaultLang);

//   // функция для переключения языка
//   const changeLang = (newLang) => {
//     if (newLang !== lang) setLang(newLang);
//   };

//   // 3) Здесь можно держать словарь переводов
//   const translations = {

import React, { createContext, useContext, useState, useEffect } from "react";

// 1) Создаём контекст
const LanguageContext = createContext();

export function LanguageProvider({ children, defaultLang = "ru" }) {
  // 2) Инициализация из localStorage или defaultLang
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("lang") || defaultLang;
  });

  // 3) Сохраняем в localStorage при каждом изменении
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  // функция для переключения языка
  const changeLang = (newLang) => {
    if (newLang !== lang) setLang(newLang);
  };

  // Здесь можно держать словарь переводов
  const translations = {
    ru: {
      // NavBar
      navBtnMain: "Главная",
      navBtnServices: "Услуги",
      navBtnReferals: "Реферальная программа",
      navBtnLogin: "Войти",
      langBtnFlag: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="15"
          viewBox="0 0 16 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="#3D58DB"
          />
          <mask
            id="mask0_270_51699"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="12"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H16V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_270_51699)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V4H16V0H0Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 8V12H16V8H0Z"
              fill="#C51918"
            />
          </g>
        </svg>
      ),

      // NavBar Menu
      navHeader1: "Сервера",
      navHeader2: "Хостинги",
      navHeader3: "Другие услуги",

      navHeader1_1: "Виртуальный сервер",
      navHeader1_2: "Выделенный сервер",

      navHeader2_1: "Виртуальный хостинг",

      navHeader3_1: "Домен",

      // Footer
      footerServicesHeader: "услуги",
      footerContactsHeader: "контакты",
      footerSocialHeader: "соц. сети",
      footerInfoHeader: "информация",
      footerOtherHeader: "другое",

      footerServicesBtn1: "выделенный сервер",
      footerServicesBtn2: "виртуальный сервер",
      footerServicesBtn3: "виртуальный хостинг",

      footerContactsBtn2: "Поддержка в Telegram",

      footerSocialBtn1: "канал telegram",
      footerSocialBtn3: "вконтакте",

      footerInfoBtn1: "база знаний",
      footerInfoBtn2: "о дата-центре",
      footerInfoBtn3: "реферальная программа",

      footerOtherBtn1: "брендбук",

      footerBottomInfo1: "QWINS Hosting, 2024. Все права защищены.",
      footerBottomInfo2: "Политика конфиденциальности",
      footerBottomInfo3: "Условия предоставления услуг",

      // Main Banner
      mainBannerHeader1: "Современный облачный",
      mainBannerHeader2: "хостинг провайдер",

      mainBannerDescr1:
        "Производительность и надежность гарантируют бесперебойную работу",
      mainBannerDescr2:
        "проектов с высокой доступностью. Мы предлагаем выделенные",
      mainBannerDescr3: "ресурсы и установку любой ОС или ISO-образа.",

      mainBannerBtn: "перейти к тарифам",

      // Pros Cards 1
      prosCard1Header1: "Современное оборудование",
      prosCard1Header2: "Работа на",
      prosCard1Header3: "Техническая поддержка",
      prosCard1Header4: "Надежность и доступность",

      prosCard1Descr1:
        "Выбирая наш хостинг, вы можете быть уверены в надежности и эффективности работы.",
      prosCard1Descr2:
        "Если вы арендуете сервер, Вы можете быть уверены, что получите полный доступ к его ресурсам.",
      prosCard1Descr3:
        "Наша команда всегда готова помочь вам решить любые вопросы и спорные ситуации в любое время суток.",
      prosCard1Descr4:
        "Наша команда обеспечивает уровень доступности всех сервисов не ниже 98% в год, что существенно минимизирует риск недоступности вашего проекта.",

      // Minor Header 1
      minorHeader1: "Надежная платформа для ваших проектов",
      minorHeader1Descr1:
        "Наши серверы гарантируют стабильную работу вашего бизнеса, обеспечивая",
      minorHeader1Descr2:
        "необходимую мощность и надежность для решения самых сложных задач.",

      // Pros Cards 2
      prosCards2Header1: "Удобная панель управления",
      prosCards2Header2: "Быстрое развертывание",
      prosCards2Header3: "Мощные облачные вычисления",

      prosCards2Descr1:
        "Полный контроль над вашими ресурсами с интуитивно понятным интерфейсом для эффективного управления серверами.",
      prosCards2Descr2:
        "Мгновенный запуск сервера после оплаты обеспечивает быструю готовность к работе для проектов любого типа.",
      prosCards2Descr3:
        "Оптимизированная инфраструктура обеспечивает высокую производительность для проектов любого масштаба.",

      // Minor Header 2
      minorHeader2: "Приобретайте наши услуги в Telegram",
      minorHeader2Descr1:
        "Всего несколько простых шагов — и ваш сервер уже у вас!",

      // Guide Cards
      guideHeader1: "1. Запустите бота, введя команду: /start",
      guideHeader2: "2. Выберите удобный способ пополнения",
      guideHeader3: "3. Найдите подходящий сервер для покупки",
      guideHeader4_1: "Переходите в наш",
      guideHeader4_2: "Telegram Бот",

      // Minor Header 3
      minorHeader3: "Что думают наши клиенты о нас?",
      minorHeader3Descr1:
        "Здесь собраны отзывы клиентов, которые воспользовались нашими услугами.",

      // Feedback Cards
      fdHeader1: "Рассказчик",
      fdHeader2: "brellan",
      fdHeader3: "caspSOFT",
      fdHeader4: "Рассказчик",
      fdHeader5: "brellan",

      fdDescr1:
        "С данным селлером работаем уже не первый раз, всё четко и быстро, доволен товаром, получил за отзыв +rep",
      fdDescr2:
        "Пользовался услугами данного селлера нераз на других проектах, все всегда проходило гладко и быстро. Одним словом - Получил за отзыв",
      fdDescr3:
        "Дедик идеально выполнял свою работу решил продлевать на месяц немного не хватило чел сделал скидку советую",
      fdDescr4:
        "С данным селлером работаем уже не первый раз, всё четко и быстро, доволен товаром, получил за отзыв +rep",
      fdDescr5:
        "Пользовался услугами данного селлера нераз на других проектах, все всегда проходило гладко и быстро. Одним словом - Получил за отзыв",

      fdPlaceholder: "Отзыв клиента · ",

      // Questions Module
      qMinorHeader: "Частые вопросы",

      qHeader1: "Тестовый период",
      qHeader2: "В чём отличие между виртуальным и выделенным сервером?",
      qHeader3: "DDoS защита",
      qHeader4: "Виртуализация",

      qDescr1:
        "К сожалению, мы не можем предоставить вам тестовый период. Однако если по каким-либо причинам сервер вам не подойдет, мы с радостью вернем вам деньги в соответствии с нашей политикой предоставления услуг, за исключением акционных тарифов (DE-1, NL-1, FI-1 и EE-1), по которым возврат денег не предусмотрен ни при каких обстоятельствах.",
      qDescr2:
        "Виртуальный сервер использует часть ресурсов физического сервера, на котором запущена виртуальная машина. Вы можете полностью распоряжаться этими ресурсами, и они не будут использоваться другими пользователями физического сервера. Выделенный сервер, в отличие от виртуального, использует все 100% ресурсов, поскольку представляет собой полноценную физическую машину.",
      qDescr3:
        "Наша система защиты легко интегрируется со всеми облачными серверами, не требуя дополнительных настроек и оплаты. Она работает непрерывно, эффективно блокируя атаки мощностью до 2 тбит/с. Эта система подходит для любых приложений, включая игровые серверы и высоконагруженные интернет-проекты. Доверьтесь нам, и вы всегда будете под надёжной защитой.",
      qDescr4:
        "Все облачные серверы работают на базе виртуализации KVM, что обеспечивает полную изоляцию каждого сервера от остальных. Это даёт вам полный доступ к ядру системы и брандмауэру.",

      qCardHeader1: "База знаний",
      qCardHeader2: "Не нашли ответ на свой вопрос?",

      qCardDescr1: "Наша команда собрала здесь полезные советы.",
      qCardDescr2: "Задайте его нам в панели управления, либо в Telegram.",

      qCardLink1: "Перейти",
      qCardLink2: "Задать вопрос",

      // Data Center
      DCMainColHeader1: "расположение",
      DCMainColHeader2: "tier III",
      DCMainColHeader3: "уменьшенная задержка",
      DCMainColHeader4: "доступность",

      DCMainColText1:
        "Am Kronberger Hang 6, 65824 Schwalbach am Taunus, Germany",
      DCMainColText2:
        "увеличенные резервные мощности и отсутствие простоев во время ремонта.",
      DCMainColText3:
        "Благодаря подключению к множеству точек обмена трафиком, например такие как: DEC-IX, NL-IX, 1-IX и другие.",
      DCMainColText4:
        "SLA в 99,8% обеспечивается через полное резервирование всех систем.",

      DCFooter: "дата центр",

      DCCardHeader1: "Надежная система охраны",
      DCCardHeader2: "Защита от атак до 2 тбит",
      DCCardHeader3: "Геопозиции",

      DCCardText1:
        "В ЦОД используются различные меры безопасности, включая видеонаблюдение, биометрическую идентификацию и охранную сигнализацию. Также используются системы противопожарной защиты и усиленные системы безопасности.",
      DCCardText2:
        "Наша система безопасности оснащена самыми современными технологиями, которые позволяют обнаруживать и предотвращать любые DDoS-атаки. Это сводит к минимуму вероятность возникновения проблем на сетевом уровне и обеспечивает стабильность ваших услуг.",
      DCCardText3:
        "Мы предоставляем услуги в 5 локациях, а именно: В Германии, Финляндии, Нидерландах, Эстонии и России.",

      DCMinorBannerText1:
        "c его помощью вы можете проверять доступность серверов, оценивать скорость",
      DCMinorBannerText2:
        "соединения, а также проводить трассировку маршрутов в реальном времени.",

      DCqHeader1: "Как обеспечивается надежность работы серверов в ЦОД?",
      DCqHeader2: "Какую роль играет местоположение ЦОД хостинг-провайдера?",
      DCqHeader3: "Какие преимущества у данных ЦОД?",

      DCqText1:
        "Надежность работы серверов достигается благодаря резервированию источников питания, системам охлаждения и интернет-каналам. В случае возникновения проблем предусмотрены различные меры, которые позволяют серверам продолжать функционировать бесперебойно.",
      DCqText2:
        "Расположение дата-центров играет ключевую роль в обеспечении высокой доступности серверов и их быстрого реагирования. Мы тщательно выбирали места для наших дата-центров, чтобы обеспечить обширный географический охват и обеспечить нашим клиентам из разных уголков мира мгновенный доступ к серверам.",
      DCqText3:
        "Мы выбрали эти дата-центры, потому что они соответствуют уровню Tier III и обладают высокой степенью безопасности и надежности. Наши дата-центры оснащены уникальной системой противопожарной защиты, а также имеют усиленную систему защиты и высокие стандарты безопасности, включая контроль доступа, видеонаблюдение и охранную сигнализацию.",

      // Virtual Servers Page
      VSMainBannerHeader: "Виртуальные сервера",
      VSMainBannerText1: "Виртуальные серверы, оснащенные мощными",
      VSMainBannerText2: " процессорами AMD и быстрыми",
      VSMainBannerText3: " SSD накопителями NVMe.",
      size: "Дисковое пространство",
      ddos: "Защита DDoS-атак",
      ram: "ОЗУ",
      vcpu: "Кол-во виртуальных ядер",
      networks: "Сети",
      speed: "Скорость порта",

      OSHeader1: "Операционные ",
      OSHeader2: "системы",
      OSText: "подберем вам то, что нужно",

      VSCountryCardsPrice1_1: "2 $ /месяц",
      VSCountryCardsPrice1_2: "3.84 $ /месяц",
      VSCountryCardsPrice1_3: "3.84 $ /месяц",
      VSCountryCardsPrice1_4: "3.84 $ /месяц",

      VSCountryCardsRAM1_1: "1 ГБ",
      VSCountryCardsRAM1_2: "1 ГБ",
      VSCountryCardsRAM1_3: "1 ГБ",
      VSCountryCardsRAM1_4: "1 ГБ",

      VSCountryCardsSize1_1: "10 ГБ",
      VSCountryCardsSize1_2: "10 ГБ",
      VSCountryCardsSize1_3: "10 ГБ",
      VSCountryCardsSize1_4: "10 ГБ",

      VSCountryCardsDDOS1_1: "2 тб/с.",
      VSCountryCardsDDOS1_2: "2 тб/с.",
      VSCountryCardsDDOS1_3: "2 тб/с.",
      VSCountryCardsDDOS1_4: "2 тб/с.",

      VSCountryCardsPrice2_1: "2 $ /месяц",
      VSCountryCardsPrice2_2: "3.84 $ /месяц",
      VSCountryCardsPrice2_3: "3.84 $ /месяц",
      VSCountryCardsPrice2_4: "3.84 $ /месяц",

      VSCountryCardsRAM2_1: "1 ГБ",
      VSCountryCardsRAM2_2: "1 ГБ",
      VSCountryCardsRAM2_3: "1 ГБ",
      VSCountryCardsRAM2_4: "1 ГБ",

      VSCountryCardsSize2_1: "10 ГБ",
      VSCountryCardsSize2_2: "10 ГБ",
      VSCountryCardsSize2_3: "10 ГБ",
      VSCountryCardsSize2_4: "10 ГБ",

      VSCountryCardsDDOS2_1: "2 тб/с.",
      VSCountryCardsDDOS2_2: "2 тб/с.",
      VSCountryCardsDDOS2_3: "2 тб/с.",
      VSCountryCardsDDOS2_4: "2 тб/с.",

      VSMinorHeader: "Почему наш сервер идеален?",
      VSMinorHeaderText: "Мы стараемся быть идеальными во всем",

      VSSwitchBtn1: "Германия",
      VSSwitchBtn2: "Финляндия",
      VSSwitchBtn3: "Нидерланды",
      VSSwitchBtn4: "Россия",
      VSSwitchBtn5: "Эстония",

      VSBuyBtnText: "Заказать",

      VSProsHeader1: "СуперХард!",
      VSProsHeader2: "Виртуальное реально",
      VSProsHeader3: "Техническая поддержка",
      VSProsHeader4: "Резервное копирование",
      VSProsHeader5: "Скорость зашкаливает",
      VSProsHeader6: "Диски",
      VSProsHeader7: "Ваш сервер – ваши правила",
      VSProsHeader8: "Полный контроль",
      VSProsHeader9: "Раз – и готово",

      VSProsText1:
        "Мы используем только собственное, проверенное оборудование последнего поколения от ведущих мировых производителей.",
      VSProsText2:
        "Наши серверы созданы на основе технологии KVM, которая обеспечивает полную эмуляцию отдельных компонентов компьютера: процессора, оперативной памяти, дискового накопителя и сетевого интерфейса.",
      VSProsText3:
        "Мы всегда готовы прийти на помощь, когда у вас возникают технические вопросы, в любое время дня и ночи. С радостью окажем поддержку и сделаем всё возможное, чтобы ваши проблемы были решены.",
      VSProsText4:
        "Для каждого из виртуальных серверов Вы можете подключить услугу резервного копирования за 20% от стоимости сервера на месяц.",
      VSProsText5:
        "Наши сервера работают на портах со скоростью 1-10 Гбит/с. Ваши сайты будут грузиться практически мгновенно. Нет. Просто мгновенно.",
      VSProsText6_1:
        "Мы применяем исключительно NVMe-накопители типа Datacenter, обеспечивающие высокую надежность и невероятную скорость чтения и записи.",
      VSProsText6_2: "",
      VSProsText7:
        "Выберите операционную систему, которая вам удобнее всего, и мы установим её на ваш сервер.",
      VSProsText8:
        "Мы предлагаем широкий ассортимент панелей управления, среди которых есть и бесплатные варианты. Выберите наиболее подходящую для вас и управляйте сервером с правами администратора.",
      VSProsText9:
        "После того как вы закажете и оплатите виртуальный сервер, он будет предоставлен вам всего за 120 секунд. Процесс осуществляется в автоматическом режиме.",

      VSMinorBannerHeader: "Прямое подключение до 10 Гбит/с",
      VSMinorBannerHeaderText_1:
        "Каждый клиент, помимо подключения к крупнейшим операторам, точкам обмена трафиком и ",
      VSMinorBannerHeaderText_2:
        "интернет-провайдерам, получает канал для своего сервера со скоростью до 10 Гбит/с. ",
      VSMinorBannerHeaderText_3:
        "Это позволяет осуществлять молниеносную передачу данных между клиентом и сервером.",

      DSMinorBannerHeader: "Прямое подключение до 1 Гбит/с",
      DSMinorBannerHeaderText_1:
        "Каждый клиент, помимо подключения к крупнейшим операторам, точкам обмена трафиком и ",
      DSMinorBannerHeaderText_2:
        "интернет-провайдерам, получает канал для своего сервера со скоростью до 1 Гбит/с. ",
      DSMinorBannerHeaderText_3:
        "Это позволяет осуществлять молниеносную передачу данных между клиентом и сервером.",

      DSMainBannerHeader: "Выделенные серверы",
      DSMainBannerText1: "Выделенные серверы с высокой пропускной ",
      DSMainBannerText2: "способностью — идеальное решение для ",
      DSMainBannerText3: "проектов, требующих мощной инфраструктуры.",

      RMainBanner1: "Ресурсы бренда",
      RMainBanner2: "Спасибо что вы с нами",
      RMinorHeader1: "Аватар",
      RMinorHeader2: "Цвета",
      RMinorHeader3: "Логотип",

      // Privacy Page
      PPMainBlockContent: [
        {
          header: "Общие положения",
          items: [
            "Настоящая политика обработки персональных данных определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных сервиса QWINS Hosting (далее – Оператор).",
            "Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.",
            "Настоящая политика оператора в отношении обработки персональных данных (далее – Политика) применяется ко всей информации, которую оператор может получить о посетителях веб-сайта https://qwins.co",
          ],
        },
        {
          header: "Осведомленность о GDPR",
          items: [
            "Оператор признает, что он обязан соблюдать положения Общего регламента по защите данных (GDPR) в отношении граждан и резидентов Европейского Союза.",
            "Права субъектов данных: В соответствии с GDPR, пользователи имеют следующие права:",
            "Право на доступ к своим персональным данным.",
            "Право на исправление неточных или неполных данных.",
            "Право на удаление персональных данных («право быть забытым»).",
            "Право на ограничение обработки персональных данных.",
            "Право на перенос данных.",
            "Право возражать против обработки персональных данных.",
            "Согласие: Оператор обрабатывает персональные данные Пользователей на основе явного согласия, предоставленного Пользователем, в частности, для маркетинговых целей.",
            "Передача данных: Трансграничная передача персональных данных будет осуществляться только в страны, обеспечивающие адекватный уровень защиты данных, или на условиях стандартных контрактных клаузул, утвержденных Европейской комиссией.",
            "Данные о контактах для вопросов и жалоб, связанных с GDPR: Пользователи могут обращаться по вопросам защиты данных и GDPR на электронный адрес: help@qwins.co",
            "Регулярное обновление политики: Оператор периодически пересматривает и обновляет эту политику, чтобы обеспечить её соответствие актуальным требованиям GDPR.",
          ],
        },
        {
          header:
            "Оператор может обрабатывать следующие персональные данные пользователя",
          items: [
            "Фамилия, имя, отчество;",
            "Электронный адрес;",
            "Номер телефона;",
            "Реквизиты документа, удостоверяющего личность;",
            "IP адрес;",
            "Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики (Google Analytics и других).",
            "Вышеперечисленные данные далее по тексту политики объединены общим понятием персональные данные.",
          ],
        },
        {
          header: "Цели обработки персональных данных",
          items: [
            "Информирование пользователя посредством отправки электронных писем;",
            "Предоставление доступа пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте;",
            "Связь с пользователем по указанным контактам;",
            "Оказание услуг пользователю;",
            "Идентификация пользователя;",
            "Обеспечение безопасности пользователя;",
            "Оператор имеет право направлять пользователю уведомления о новых продуктах и услугах, специальных предложениях и различных событиях.",
            "Пользователь всегда может отказаться от получения информационных сообщений, направив оператору письмо на адрес электронной почты help@qwins.co с пометкой «Отказ от уведомлениях о новых продуктах и услугах и специальных предложениях».",
            "Обезличенные данные пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях пользователей на сайте, улучшения качества сайта и его содержания.",
            "Персональные данные могут использоваться для идентификации клиента и выполнения операций с применением идентификации.",
          ],
        },
        {
          header:
            "Порядок сбора, хранения, передачи и других видов обработки персональных данных",
          items: [
            "Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных.",
            "Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.",
            "Персональные данные пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства.",
            "В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления оператору уведомление на адрес электронной почты оператора help@qwins.co с пометкой «Актуализация персональных данных».",
            "Срок обработки персональных данных является неограниченным.",
            "Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив оператору уведомление посредством электронной почты на электронный адрес оператора help@qwins.co с пометкой «Отзыв согласия на обработку персональных данных».",
          ],
        },
        {
          header: "Трансграничная передача персональных данных",
          items: [
            "Оператор до начала осуществления трансграничной передачи персональных данных обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных.",
            "Трансграничная передача персональных данных на территории иностранных государств, не отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия согласия в письменной форме субъекта персональных данных на трансграничную передачу его персональных данных и/или исполнения договора, стороной которого является субъект персональных данных.",
          ],
        },
        {
          header: "Заключительные положения",
          items: [
            "Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к оператору с помощью электронной почты help@qwins.co.",
            "В данном документе будут отражены любые изменения политики обработки персональных данных оператором. Политика действует бессрочно до замены ее новой версией.",
            "Актуальная версия политики в свободном доступе расположена в сети интернет по адресу https://qwins.co/privacy",
          ],
        },
      ],

      PPNavigationHeader: "Навигация",
      PPPrivacyHeader: "Политика конфиденциальности",

      // Terms Page
      TPMainBlockContent: [
        {
          header: "Зона ответственности компании",
          items: [
            "Проблемы с хост-машинами и связью — ответственность компании.",
            "Проблемы с операционной системой, любым программным обеспечением, установленным на виртуальном сервере клиентом — ответственность клиента.",
          ],
        },
        {
          header: "Порядок оплаты",
          items: [
            "Внесение платы за услуги компании клиентом производится в порядке 100% предоплаты.",
            "Услуги предоставляются в течение 24 часов после оплаты, если не указано иное.",
            "Услуга считается предоставленной клиенту в полном объеме с момента предоставления клиенту доступа к услуге. Никакой иной момент не может трактоваться как момент исполнения компанией своих обязательств.",
            "Оплата физическими лицами производится только посредством электронных платежей.",
            "Оплата хостинга производится в долларах на основании действующих тарифов, опубликованных на официальном сайте Компании по адресу: https://qwins.co",
            "К оплате может добавляться комиссия посредников и платежных систем.",
            "В случае отсутствия оплаты следующего периода хостинга, компания приостанавливает предоставление услуг.",
            "После окончания оплаченного периода услуги данные сохраняются до 8 (восьми) часов. После этого срока все данные клиента, относящиеся к оказываемой услуге, могут быть удалены без возможности восстановления.",
            "В случае поступления полной оплаты после приостановки предоставления услуги возобновление предоставления услуги производится в течение 24 (двадцати четырех) часов, если не указано иное.",
          ],
        },
        {
          header: "Возврат средств",
          items: [
            "Клиент вправе получить возврат авансового платежа (платежей) с баланса в личном кабинете, если общая сумма не менее 40$.",
            "Клиент вправе получить возврат за активированную услугу (хостинг), если с момента активации прошло не более 24 часов, за исключением промо-тарифов DE-1 / FI-1 / NL-1 и EE-1, но не более 50% от стоимости услуги.",
            "Возврат средств осуществляется тем же платежным методом и на ту же карту (кошелек), которые использовались при совершении платежа.",
            "Для возврата средств необходимо создать запрос в поддержку в личном кабинете по адресу https://my.qwins.co.",
            "Запрос на возврат рассматривается в течение 7 рабочих дней с момента получения запроса от клиента. Срок поступления денег на ваш счет зависит от вашего банка или кошелька.",
            "В случае нарушения клиентом данного пользовательского соглашения и (или) установленного факта мошеннических действий со стороны клиента компания вправе отказать клиенту в возврате средств.",
            "В случае, если по вине клиента компанией были понесены убытки, из суммы возврата может быть вычтена сумма понесенных компанией издержек.",
          ],
        },
        {
          header: "Права и обязанности клиента",
          items: [
            "Клиенту предоставляется доступ (если не оговорено иное) к серверу и клиент несет всю связанную с этим ответственность.",
            "Клиент имеет право устанавливать и использовать любое ПО на своем сервере, в случае если оно является легальным и не нарушает авторских и смежных прав, а также норм действующего законодательства Великобритании.",
            "Клиент обязан следить за соответствием всех размещенных материалов, используемого ПО, контентом, размещенным на сервере, и отвечать за его соответствие нормам действующего законодательства Великобритании.",
            "Клиент имеет право использовать свой хостинг в любых целях, кроме целей, противоречащих законодательству Великобритании и законам об авторских и смежных правах.",
            "Все вопросы, связанные с работоспособностью хостинга клиента, принимаются только в запросах в поддержку в личном кабинете по адресу https://my.qwins.co.",
            "В случае блокировки хостинга клиента по жалобе и/или в следствии других причин 1 (один) или более 1 (одного) раза в месяц (скан сети, исходящие DoS-атаки и др.) и непринятия клиентом мер по поступившей жалобе, компания вправе досрочно остановить предоставление услуги и заблокировать клиента без возможности возврата средств.",
            "Клиент вправе в течение 2 (двух) рабочих дней после получения услуг подписать акт об оказанных услугах либо предоставить компании письменный мотивированный отказ от подписания акта.",
            "В случае, если в течение 2 (двух) рабочих дней после оказания услуги, клиент не подписал акт, либо не направил компании мотивированные возражения, акт считается подписанным со стороны клиента. В указанном случае услуги считаются оказанными компанией надлежащим образом в полном объеме и дополнительных документов не требуется.",
          ],
        },
        {
          header: "Права и обязанности компании",
          items: [
            "Услуги компании предоставляются «как есть», компания оставляет за собой право пересмотреть правила предоставления услуг, в том числе ценовую политику и характеристики тарифов в любой момент, без предварительного уведомления и в одностороннем порядке. Новые правила вступают в действие в момент опубликования их на официальном сайте компании.",
            "Компания обязуется поддерживать надлежащее качество хост-машин и устранять все неисправности в кратчайшие сроки.",
            "Компания обязуется оповещать о проведении плановых технических работ посредством электронного письма на адрес клиента. К этому пункту не относятся форс-мажорные ситуации и внеплановые работы.",
            "Компания не несет ответственности за невозможность доступа к сервисам по вине третьих лиц.",
            "Компания оставляет за собой право остановки сервисов и серверов клиента для проведения планового обслуживания, из-за DoS и сетевых атак, в результате стихийных бедствий и других форс-мажорных обстоятельств.",
            "Компания осуществляет услуги технической поддержки клиентов на основании запроса клиента через личный кабинет по тарифам, опубликованным на официальном сайте компании, расположенном по адресу https://qwins.co.",
            "Компания не несет ответственности за работу стороннего ПО на серверах компании, в том числе ПО, приобретенного в компании.",
            "Компания не несет ответственности перед пользователями или любыми третьими лицами за любой ущерб, включая упущенную выгоду, вызванный использованием услуг компании.",
          ],
        },
        {
          header: "Запрещенный контент и ПО",
          items: [
            "На хостинге запрещено размещение порнографии, в том числе ссылок и рекламы, содержащей порнографические сцены.",
            "Запрещено размещение информации и программного обеспечения, противоречащих и/или запрещенных законодательством Великобритании, законом об авторских и смежных правах.",
            "Запрещено размещение ПО для ботнетов, граббинга, фишинга и других целей, явно противоречащих легальной работе в сети Интернет.",
            "Осуществление массовых почтовых рассылок запрещено, за исключением случаев, санкционированных компанией.",
            "Запрещено размещение сервисов (в том числе с платным или приватным доступом), которые могут служить вспомогательными средствами для противоправных действий в сети Интернет.",
            "Запрещено размещение сетевых сканеров, прокси-чекеров и подобного программного обеспечения.",
            "Запрещен майнинг криптовалют и другая связанная с этим деятельность.",
          ],
        },
        {
          header: "Прекращение предоставления услуг по инициативе компании",
          items: [
            "Компания оставляет за собой право прекратить предоставление услуг по собственному усмотрению, немедленно и без предупреждения в случае:",
            "Несанкционированного распространения или копирования программного обеспечения, защищенного авторским правом, нарушения законов Великобритании, международных норм и соглашений, экспортных ограничений, мошенничества, оборота порнографических материалов, наркотиков и других незаконных видов деятельности.",
            "Массовых почтовых рассылок, на получение которых не давалось явного согласия пользователей.",
            "Клеветы, распространения личной информации, нарушения авторских и смежных прав, интеллектуальных прав.",
            "Размещения порнографического контента во всех его проявлениях, в том числе ссылок на сайты с порнографическим содержанием.",
            "Нарушения прав частной жизни и собственности, размещения клеветнической и оскорбительной информации, пособничества, подстрекательства к межнациональной розни, убийству, терроризму, насилию в любых формах.",
            "Препятствования нормальной и стабильной работе серверов, сетевых ресурсов и всей инфраструктуры компании.",
            "Указания заведомо недостоверных данных клиента или отказа от их подтверждения.",
            "Некорректного общения с сотрудниками компании, включая использование ненормативной лексики и распространение клеветнической информации о компании.",
            "Компания оставляет за собой право передать информацию о клиенте по официальному запросу правоохранительных органов.",
          ],
        },
        {
          header: "Компания не несет ответственности",
          items: [
            "За выбор клиентом операционной системы, программного обеспечения и последствия, которые это может повлечь, в том числе до полной потери данных, мы не несем ответственности за данные, которые находятся на Вашем сервере",
            "Ни за какие виды прямого или косвенного ущерба, потерю информации, деловую репутацию и иные случаи ущерба.",
            "Компания не проводит проверку контента, размещенного на хостинге клиента. Исключение составляют случаи поступления мотивированной жалобы от третьей стороны.",
          ],
        },
        {
          header: "Гарантия уровня сервиса",
          items: [
            "Компания гарантирует сохранение доступности серверов хостинга на уровне 98% в месяц.",
            "В случае нарушения пункта 9.1 настоящей оферты каждый полный день (24 часа) простоя услуги компенсируется клиенту в двойном размере.",
            "Компенсация начисляется в виде дополнительных дней обслуживания и не может быть выплачена в денежном выражении.",
            "Компенсация начисляется на основании запроса в поддержку в личном кабинете по адресу https://my.qwins.co",
          ],
        },
        {
          header: "Email информирование",
          items: [
            "Регистрация клиента в личном кабинете по адресу https://my.qwins.co означает автоматическое согласие клиента с получением информационных e-mail сообщений, в том числе с предложениями услуг компании.",
            "Отказ от получения уведомлений возможен только в случае полного закрытия аккаунта клиента.",
            "Компания снимает с себя ответственность за неполучение клиентом важных информационных сообщений посредством e-mail сообщений.",
          ],
        },
      ],

      TPNavigationHeader: "Навигация",
      TPPrivacyHeader: "Условия предоставления услуг",

      // Referral Page
      RPMainBannerHeader: "Реферальная программа",
      RPMainBannerText1:
        "Эксклюзивная реферальная программа для наших дорогих клиентов,",
      RPMainBannerText2: " которая позволит вам зарабатывать реальные деньги.",
      RPMainBannerBtn: "стать партнером",

      RPProsHeader1: "Партнёрский процент",
      RPProsHeader2: "Пассивный доход",

      RPProsText1:
        "Приводите клиентов в наш хостинг, рассказывая о нас в интернете. Когда приглашённый вами пользователь зарегистрирует аккаунт по вашей реферальной ссылке, вы получите 5% от суммы его расходов.",
      RPProsText2:
        "Для получения стабильного дохода достаточно привлечь клиента, который будет активно пользоваться нашими услугами. Чем дольше он остается с нами и чем больше услуг использует, тем выше будет ваш доход.",

      RPNotifHeader: "Реферальная программа",
      RPNotifText: "Вы получили денежное вознаграждение",

      RPTextBlock1:
        "1. Не стоит использовать спам-рассылки, связанные с QWINS Hosting, для привлечения клиентов. Также нельзя распространять недостоверную информацию о наших услугах, например, указывать цены, не соответствующие реальности.",
      RPTextBlock2:
        "2. Реферальная программа действует бессрочно. Пригласив нового клиента и получив оплату за любую услугу, вы будете получать 5% от всех его покупок даже спустя 5 лет.",
      RPTextBlock3:
        "3. Средства, которые вы заработали благодаря реферальной программе, автоматически начисляются после того, как клиент закажет услугу. Вы можете отправить запрос на вывод средств в тот же день.",
      RPTextBlock4:
        "4. В случае нарушения клиентом правил реферальной программы выплаты по ней могут быть отменены без предварительного уведомления.",

      // Tariffs
      // dedicated page
      DPGer: [
        {
          header: "i7-6700",
          price: "$55 в месяц",
          cpu: "Intel Core i7-6700",
          vcpu: "x 8",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i7-7700",
          price: "$55 в месяц",
          cpu: "Intel Core i7-7700",
          vcpu: "x 8",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i7-8700",
          price: "$60 в месяц",
          cpu: "Intel Core i7-8700",
          vcpu: "x 12",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "E3-1275v6",
          price: "$60 в месяц",
          cpu: "Intel Xeon E3-1275v6",
          vcpu: "x 12",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R5-3600",
          price: "$70 в месяц",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 12",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R5-3600",
          price: "$80 в месяц",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 12",
          ram: "128 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i9-9900K",
          price: "$100 в месяц",
          cpu: "Intel Core i9-9900K",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i5-13500",
          price: "$80 в месяц + $50 установочный платеж",
          cpu: "Intel Core i5-13500",
          vcpu: "x 20",
          ram: "64 ГБ",
          size: "2x512 ГБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i9-13900",
          price: "$155 в месяц + $50 установочный платеж",
          cpu: "Intel Core i9-13900",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i9-13900",
          price: "$175 в месяц + $50 установочный платеж",
          cpu: "Intel Core i9-13900",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$95 в месяц",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 3900",
          price: "$100 в месяц",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "64 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 3900",
          price: "$150 в месяц",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 5950X",
          price: "$150 в месяц",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "2x3.84 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502",
          price: "$200 в месяц",
          cpu: "AMD EPYC 7502",
          vcpu: "x 64",
          ram: "128 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$220 в месяц",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "128 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$300 в месяц",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "256 ГБ",
          size: "1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$420 в месяц",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "512 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$700 в месяц",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "1024 ГБ",
          size: "3.84 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i9-12900K",
          price: "$180 в месяц",
          cpu: "Intel Core i9-12900K",
          vcpu: "x 24",
          ram: "128 ГБ",
          size: "4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 9454P",
          price: "$300 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "128 ГБ",
          size: "2x4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 9454P",
          price: "$300 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "256 ГБ",
          size: "2x4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 9454P",
          price: "$600 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "512 ГБ",
          size: "2x4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 9454P",
          price: "$1000 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "1024 ГБ",
          size: "4x4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 7950X",
          price: "$145 в месяц + $50 установочный платеж",
          cpu: "AMD Ryzen 9 7950X",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "2x2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 PRO 8700 GE",
          price: "$80 в месяц + $50 установочный платеж",
          cpu: "AMD R7 PRO 8700 GE",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "2x512 ГБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 PRO 8700 GE",
          price: "$110 в месяц + $50 установочный платеж",
          cpu: "AMD R7 PRO 8700 GE",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "2x512 ГБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 7700",
          price: "$100 в месяц + $50 установочный платеж",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 7700",
          price: "$130 в месяц + $50 установочный платеж",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i5-13500",
          price: "$105 в месяц + $50 установочный платеж",
          cpu: "Intel Core i5-13500",
          vcpu: "x 20",
          ram: "128 ГБ",
          size: "2x512 ГБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 7700",
          price: "$150 в месяц + $50 установочный платеж",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "192 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$220 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "128 ГБ",
          size: "2x3.84 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$220 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "256 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$350 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "384 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$450 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "512 ГБ",
          size: "3x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$600 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "768 ГБ",
          size: "4x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i7-6700",
          price: "$65 в месяц",
          cpu: "Intel Core i7-6700",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "2x4 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i7-8700",
          price: "$120 в месяц",
          cpu: "Intel Core i7-6700",
          vcpu: "x 12",
          ram: "64 ГБ",
          size: "2x6 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i7-8700",
          price: "$160 в месяц",
          cpu: "Intel Core i7-8700",
          vcpu: "x 12",
          ram: "64 ГБ",
          size: "2x8 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$160 в месяц",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "2x12 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$200 в месяц",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "2x16 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$160 в месяц",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "16 ТБ + 2х8 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R5-3600",
          price: "$250 в месяц",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "4x16 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$330 в месяц",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "10x16 ТБ HDD + 2x1 ТБ SSD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "W-2145",
          price: "$330 в месяц",
          cpu: "Intel Xeon W-2145",
          vcpu: "x 16",
          ram: "128 ГБ",
          size: "10x16 ТБ HDD + 2x1 ТБ SSD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R7 3700X",
          price: "$275 в месяц + $60 установочный платеж",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "4x22 ТБ HDD + 2x1 ТБ NVMe",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 3900",
          price: "$390 в месяц + $110 установочный платеж",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "128 ГБ",
          size: "8x22 ТБ HDD + 2x2 ТБ NVMe",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$600 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "256 ГБ",
          size: "14x22 ТБ HDD + 2x8 ТБ NVMe",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$690 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "512 ГБ",
          size: "14x22 ТБ HDD + 2x8 ТБ NVMe",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "EPYC 7502P",
          price: "$1000 в месяц + $110 установочный платеж",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "1024 ГБ",
          size: "14x22 ТБ HDD + 2x8 ТБ NVMe",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "i5-12500",
          price: "$300 в месяц + $110 установочный платеж",
          cpu: "Intel Core i5-12500",
          vcpu: "x 12",
          ram: "128 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$1300 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "128 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$520 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "128 ГБ",
          size: "1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$620 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "256 ГБ",
          size: "2x1.92 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$750 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "512 ГБ",
          size: "2x3.84 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$820 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "768 ГБ",
          size: "2x3.84 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$950 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "1024 ГБ",
          size: "7.68 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$1200 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "1536 ГБ",
          size: "2x7.68 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$1550 в месяц + $110 установочный платеж",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "2048 ГБ",
          size: "2x7.68 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
      ],
      DPNet: [
        {
          header: "Xeon E3-12xx",
          price: "$100 в месяц",
          cpu: "Intel Xeon E3-12xx",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "8 ТБ HDD",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 5950X",
          price: "$170 в месяц",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 5950X",
          price: "$195 в месяц",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Xeon E3-12xx",
          price: "$120 в месяц",
          cpu: "Intel Xeon E3-12xx",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x Intel Xeon E5-2680v4",
          price: "$200 в месяц",
          cpu: "2x Intel Xeon E5-2680v4",
          vcpu: "x 56",
          ram: "128 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x AMD EPYC 7551",
          price: "$355 в месяц",
          cpu: "2x AMD EPYC 7551",
          vcpu: "x 128",
          ram: "256 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x AMD EPYC 7551",
          price: "$385 в месяц",
          cpu: "2x AMD EPYC 7551",
          vcpu: "x 128",
          ram: "256 ГБ",
          size: "4 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x AMD EPYC 7451",
          price: "$250 в месяц",
          cpu: "2x AMD EPYC 7451",
          vcpu: "x 96",
          ram: "256 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "R9 7950X",
          price: "$260 в месяц",
          cpu: "AMD Ryzen 9 7950X",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M2",
          price: "$200 в месяц",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "8 ГБ",
          size: "256 ГБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M1",
          price: "$300 в месяц",
          cpu: "Apple M1",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M2",
          price: "$400 в месяц",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M2 Pro",
          price: "$500 в месяц",
          cpu: "Apple M2 Pro",
          vcpu: "x 12",
          ram: "16 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M2",
          price: "$600 в месяц",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Apple M2",
          price: "$800 в месяц",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "64 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "Intel Core i7. MacOS server",
          price: "$350 в месяц",
          cpu: "Intel Core i7",
          vcpu: "x None",
          ram: "64 ГБ",
          size: "1 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
      ],
      DPRus: [
        {
          header: "2x Intel Xeon E5-2697Av4",
          price: "$200 в месяц",
          cpu: "2x Intel Xeon E5-2697Av4",
          vcpu: "x 64",
          ram: "256 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x Intel Xeon Gold 6148",
          price: "$350 в месяц",
          cpu: "2x Intel Xeon Gold 6148",
          vcpu: "x 80",
          ram: "256 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "2x Intel Xeon E5-2470v2",
          price: "$150 в месяц",
          cpu: "2x Intel Xeon E5-2470v2",
          vcpu: "x 40",
          ram: "384 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тб/с.",
        },
        {
          header: "AMD Ryzen 9 5950X",
          price: "$200 в месяц",
          cpu: "2x Intel Xeon E5-2470v2",
          vcpu: "x 40",
          ram: "128 ГБ",
          size: "2 ТБ",
          networks: "",
          speed: "",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "AMD Ryzen 9 5950X",
          price: "$350 в месяц",
          cpu: "2x Intel Xeon E5-2470v2",
          vcpu: "x 40",
          ram: "128 ГБ",
          size: "2 ТБ",
          gpu: "RTX 3070 TI",
          networks: "",
          speed: "",
          ddos: "до 2 тбит/с.",
        },
      ],

      // Virtual Page
      VPGer: [
        {
          header: "DE-1  без технической поддержки",
          price: "$2 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 1",
          ram: "1 ГБ",
          size: "10 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 100 мбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-2",
          price: "$3.84 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 1",
          ram: "2 ГБ",
          size: "30 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-3",
          price: "$6.58 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 2",
          ram: "4 ГБ",
          size: "60 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-4",
          price: "$9 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 3",
          ram: "6 ГБ",
          size: "75 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-5",
          price: "$13.16 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 4",
          ram: "8 ГБ",
          size: "90 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-6",
          price: "$17.55 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 6",
          ram: "12 ГБ",
          size: "120 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-7",
          price: "$21.93 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "160 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-8",
          price: "$38.39 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "240 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-9",
          price: "$42 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 12",
          ram: "24 ГБ",
          size: "280 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-10",
          price: "$45 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 14",
          ram: "28 ГБ",
          size: "300 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-11",
          price: "$50 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 16",
          ram: "32 ГБ",
          size: "320 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-12",
          price: "$60 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 18",
          ram: "36 ГБ",
          size: "340 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-13",
          price: "$65.80 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 12",
          ram: "48 ГБ",
          size: "360 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-14",
          price: "$72 в месяцNicholas",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 20",
          ram: "38 ГБ",
          size: "390 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-15",
          price: "$85 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 22",
          ram: "44 ГБ",
          size: "410 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-16",
          price: "$89.93 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "440 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-17",
          price: "$95 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 24",
          ram: "48 ГБ",
          size: "470 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-18",
          price: "$115 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 28",
          ram: "50 ГБ",
          size: "500 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-19",
          price: "$130 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 30",
          ram: "52 ГБ",
          size: "530 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-20",
          price: "$150 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "560 ГБ",
          networks: "x 1 IPv4 и /64 IPv6",
          speed: "до 1 гбит/c",
          ddos: "до 2 тбит/с",
        },
        {
          header: "DE-21",
          price: "$200 в месяц",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "1024 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 1 гбит/c.",
          ddos: "до 2 тбит/с",
        },
      ],
      VPFin: [
        {
          header: "FI-1 без технической поддержки",
          price: "$2 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "1 ГБ",
          size: "10 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 100 мбит/с.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-2",
          price: "$3.84 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "2 ГБ",
          size: "30 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-3",
          price: "$6.58 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 2",
          ram: "4 ГБ",
          size: "60 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-4",
          price: "$9 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 3",
          ram: "6 ГБ",
          size: "75 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-5",
          price: "$13.16 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 4",
          ram: "8 ГБ",
          size: "90 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-6",
          price: "$17.55 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 6",
          ram: "12 ГБ",
          size: "120 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-7",
          price: "$21.93 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "160 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-8",
          price: "$38.39 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "240 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-9",
          price: "$42 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "24 ГБ",
          size: "280 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-10",
          price: "$45 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 14",
          ram: "28 ГБ",
          size: "300 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-11",
          price: "$50 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "32 ГБ",
          size: "320 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-12",
          price: "$60 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 18",
          ram: "36 ГБ",
          size: "340 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-13",
          price: "$65.80 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "48 ГБ",
          size: "360 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-14",
          price: "$72 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 20",
          ram: "38 ГБ",
          size: "390 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-15",
          price: "$85 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 22",
          ram: "44 ГБ",
          size: "410 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-16",
          price: "$89.93 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "440 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-17",
          price: "$95 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 24",
          ram: "48 ГБ",
          size: "470 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-18",
          price: "$115 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 28",
          ram: "50 ГБ",
          size: "500 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-19",
          price: "$130 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 30",
          ram: "52 ГБ",
          size: "530 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-20",
          price: "$150 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "560 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
        {
          header: "FI-21",
          price: "$200 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "1024 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с.",
        },
      ],
      VPNet: [
        {
          header: "NL-1 без технической поддержки",
          price: "$2 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 1",
          ram: "1 ГБ",
          size: "10 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 100 мбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-2",
          price: "$3.84 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 1",
          ram: "2 ГБ",
          size: "30 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-3",
          price: "$6.58 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 2",
          ram: "4 ГБ",
          size: "60 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-4",
          price: "$9 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 3",
          ram: "6 ГБ",
          size: "75 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-5",
          price: "$13.16 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 4",
          ram: "8 ГБ",
          size: "90 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-6",
          price: "$17.55 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 6",
          ram: "12 ГБ",
          size: "120 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-7",
          price: "$21.93 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "160 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-8",
          price: "$38.39 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "240 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-9",
          price: "$42 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 12",
          ram: "24 ГБ",
          size: "280 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-10",
          price: "$45 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 14",
          ram: "28 ГБ",
          size: "300 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-11",
          price: "$50 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 16",
          ram: "32 ГБ",
          size: "320 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-12",
          price: "$60 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 18",
          ram: "36 ГБ",
          size: "340 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-13",
          price: "$65.80 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 12",
          ram: "48 ГБ",
          size: "360 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-14",
          price: "$72 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 20",
          ram: "38 ГБ",
          size: "390 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-15",
          price: "$85 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 22",
          ram: "44 ГБ",
          size: "410 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-16",
          price: "$89.93 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "440 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-17",
          price: "$95 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 24",
          ram: "48 ГБ",
          size: "470 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-18",
          price: "$115 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 28",
          ram: "50 ГБ",
          size: "500 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-19",
          price: "$130 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 30",
          ram: "52 ГБ",
          size: "530 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-20",
          price: "$150 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "560 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/с",
          ddos: "до 2 тбит/с",
        },
        {
          header: "NL-21",
          price: "$200 в месяц",
          cpu: "AMD EPYC 7702",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "1024 ГБ",
          networks: "x IPv4 и /64 IPv6.",
          speed: "100 мбит/с",
          ddos: "2 тбит/с",
        },
      ],
      VPEst: [
        {
          header: "EE-1 без технической поддержки",
          price: "$2 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "1 ГБ",
          size: "10 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 100 мбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-2",
          price: "$3.84 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "2 ГБ",
          size: "30 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-3",
          price: "$6.58 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 2",
          ram: "4 ГБ",
          size: "60 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-4",
          price: "$9 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 3",
          ram: "6 ГБ",
          size: "75 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-5",
          price: "$13.16 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 4",
          ram: "8 ГБ",
          size: "90 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-6",
          price: "$17.55 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 6",
          ram: "12 ГБ",
          size: "120 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-7",
          price: "$21.93 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "16 ГБ",
          size: "160 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-8",
          price: "$38.39 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "32 ГБ",
          size: "240 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-9",
          price: "$42 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "24 ГБ",
          size: "280 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-10",
          price: "$45 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 14",
          ram: "28 ГБ",
          size: "300 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-11",
          price: "$50 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "32 ГБ",
          size: "320 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-12",
          price: "$60 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 18",
          ram: "36 ГБ",
          size: "340 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-13",
          price: "$65.80 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "48 ГБ",
          size: "360 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-14",
          price: "$72 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 20",
          ram: "38 ГБ",
          size: "390 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-15",
          price: "$85 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 22",
          ram: "44 ГБ",
          size: "410 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-16",
          price: "$89.93 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "64 ГБ",
          size: "440 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-17",
          price: "$95 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 24",
          ram: "48 ГБ",
          size: "470 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-18",
          price: "$115 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 28",
          ram: "50 ГБ",
          size: "500 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-19",
          price: "$130 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 30",
          ram: "52 ГБ",
          size: "530 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-20",
          price: "$150 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "64 ГБ",
          size: "560 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
        {
          header: "EE-21",
          price: "$200 в месяц",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "128 ГБ",
          size: "1024 ГБ",
          networks: "x 1 IPv4 и /64 IPv6.",
          speed: "до 10 гбит/c.",
          ddos: "до 2 тбит/с",
        },
      ],

      // Virtual hosting
      VHTariffs: [
        {
          header: "5 GB",
          price: "$5 в месяц",
          text: [
            "Панель управления: ISPmanager 6.",
            "Имеется поддержка Python и NodeJS.",
            "Локация: Германия.",
          ],
          tariff: [
            "50% vCore от Intel Xeon E-2276G.",
            "1 GB RAM.",
            "5 GB SSD накопителя и дополнительно $1 за каждые 5 ГБ накопителя.",
            "Бесконечное добавление сайтов.",
            "Безлимитный трафик.",
            "Бесконечное количество баз данных.",
          ],
        },
      ],
      VHMainHeader: "Виртуальный хостинг",
      VHMainText1: "Виртуальный хостинг с PHP и MYSQL для сайтов ",
      VHMainText2: "любого уровня сложности: от личных страниц до ",
      VHMainText3: "высоконагруженных проектов.",

      VHProsHeader1: "Дисковые накопители",
      VHProsHeader2: "Оборудование",
      VHProsHeader3: "Масштабируемость",

      VHProsText1:
        "Мы используем SSD-диски, чтобы обеспечить высокую скорость выполнения операций и мгновенный доступ к информации без задержек.",
      VHProsText2:
        "Мы используем хорошее оборудование. Оно проверено и соответствует правилам. Поэтому наши клиенты могут работать без проблем.",
      VHProsText3:
        "Мы предлагаем один тариф виртуального хостинга. Его можно легко изменить и сделать больше, если нужно.",

      VHMinorHeader: "Тарифный план",
      VHTariffHeader: "Тариф включает в себя:",

      okakHeader: "СТРАНИЦА НЕ РАБОТАЕТ",
      okakText: "Хз в чем проблема, но уже скоро, думаем, пофиксим.",
      provider: "Хз в чем проблема, но уже скоро, думаем, пофиксим.",
      okakButton: "ОКАК, НА ГЛАВНУЮ",
      gpu: "Видеокарта",
    },

    en: {
      // NavBar
      navBtnMain: "Home",
      navBtnServices: "Services",
      navBtnReferals: "Referral program",
      navBtnLogin: "Login",
      langBtnFlag: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="15"
          viewBox="0 0 16 12"
          fill="none"
        >
          <g clip-path="url(#clip0_270_55071)">
            <rect width="16" height="12" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 0H16V12H0V0Z"
              fill="#E31D1C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 1V2H16V1H0ZM0 3V4H16V3H0ZM0 6V5H16V6H0ZM0 7V8H16V7H0ZM0 10V9H16V10H0ZM0 12V11H16V12H0Z"
              fill="#F7FCFF"
            />
            <rect width="9" height="7" fill="#2E42A5" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.04005 2.17381L1.56997 1.80468L1.98103 2.10061H1.74829L2.21896 2.51691L2.05999 3.10061H1.811L1.56923 2.56451L1.36305 3.10061H0.748291L1.21896 3.51691L1.04005 4.17381L1.56997 3.80468L1.98103 4.10061H1.74829L2.21896 4.51691L2.05999 5.10061H1.811L1.56923 4.56451L1.36305 5.10061H0.748291L1.21896 5.51691L1.04005 6.17381L1.56997 5.80468L2.08271 6.17381L1.92329 5.51691L2.33506 5.10061H2.14514L2.56997 4.80468L2.98103 5.10061H2.74829L3.21896 5.51691L3.04005 6.17381L3.56997 5.80468L4.08271 6.17381L3.92329 5.51691L4.33506 5.10061H4.14514L4.56997 4.80468L4.98103 5.10061H4.74829L5.21896 5.51691L5.04005 6.17381L5.56997 5.80468L6.08271 6.17381L5.92329 5.51691L6.33506 5.10061H6.14514L6.56997 4.80468L6.98103 5.10061H6.74829L7.21896 5.51691L7.04005 6.17381L7.56997 5.80468L8.08271 6.17381L7.92329 5.51691L8.33506 5.10061H7.811L7.56923 4.56451L7.36305 5.10061H7.06494L6.92329 4.51691L7.33506 4.10061H7.14514L7.56997 3.80468L8.08271 4.17381L7.92329 3.51691L8.33506 3.10061H7.811L7.56923 2.56451L7.36305 3.10061H7.06494L6.92329 2.51691L7.33506 2.10061H7.14514L7.56997 1.80468L8.08271 2.17381L7.92329 1.51691L8.33506 1.10061H7.811L7.56923 0.564514L7.36305 1.10061H6.74829L7.21896 1.51691L7.05999 2.10061H6.811L6.56923 1.56451L6.36305 2.10061H6.06494L5.92329 1.51691L6.33506 1.10061H5.811L5.56923 0.564514L5.36305 1.10061H4.74829L5.21896 1.51691L5.05999 2.10061H4.811L4.56923 1.56451L4.36305 2.10061H4.06494L3.92329 1.51691L4.33506 1.10061H3.811L3.56923 0.564514L3.36305 1.10061H2.74829L3.21896 1.51691L3.05999 2.10061H2.811L2.56923 1.56451L2.36305 2.10061H2.06494L1.92329 1.51691L2.33506 1.10061H1.811L1.56923 0.564514L1.36305 1.10061H0.748291L1.21896 1.51691L1.04005 2.17381ZM7.05999 4.10061L7.21896 3.51691L6.74829 3.10061H6.98103L6.56997 2.80468L6.14514 3.10061H6.33506L5.92329 3.51691L6.06494 4.10061H6.36305L6.56923 3.56451L6.811 4.10061H7.05999ZM5.98103 4.10061L5.56997 3.80468L5.14514 4.10061H5.33506L4.92329 4.51691L5.06494 5.10061H5.36305L5.56923 4.56451L5.811 5.10061H6.05999L6.21896 4.51691L5.74829 4.10061H5.98103ZM4.21896 4.51691L4.05999 5.10061H3.811L3.56923 4.56451L3.36305 5.10061H3.06494L2.92329 4.51691L3.33506 4.10061H3.14514L3.56997 3.80468L3.98103 4.10061H3.74829L4.21896 4.51691ZM4.36305 4.10061H4.06494L3.92329 3.51691L4.33506 3.10061H4.14514L4.56997 2.80468L4.98103 3.10061H4.74829L5.21896 3.51691L5.05999 4.10061H4.811L4.56923 3.56451L4.36305 4.10061ZM3.05999 4.10061L3.21896 3.51691L2.74829 3.10061H2.98103L2.56997 2.80468L2.14514 3.10061H2.33506L1.92329 3.51691L2.06494 4.10061H2.36305L2.56923 3.56451L2.811 4.10061H3.05999ZM6.21896 2.51691L6.05999 3.10061H5.811L5.56923 2.56451L5.36305 3.10061H5.06494L4.92329 2.51691L5.33506 2.10061H5.14514L5.56997 1.80468L5.98103 2.10061H5.74829L6.21896 2.51691ZM3.98103 2.10061L3.56997 1.80468L3.14514 2.10061H3.33506L2.92329 2.51691L3.06494 3.10061H3.36305L3.56923 2.56451L3.811 3.10061H4.05999L4.21896 2.51691L3.74829 2.10061H3.98103Z"
              fill="#F7FCFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_270_55071">
              <rect width="16" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),

      // NavBar Menu
      navHeader1: "Servers",
      navHeader2: "Hosting",
      navHeader3: "Other Services",

      navHeader1_1: "Virtual Server",
      navHeader1_2: "Dedicated Server",

      navHeader2_1: "Virtual Hosting",

      navHeader3_1: "Domain",

      // Footer
      footerServicesHeader: "services",
      footerContactsHeader: "contacts",
      footerSocialHeader: "social networks",
      footerInfoHeader: "information",
      footerOtherHeader: "other",

      footerServicesBtn1: "dedicated server",
      footerServicesBtn2: "virtual server",
      footerServicesBtn3: "virtual hosting",

      footerContactsBtn2: "Support on Telegram",

      footerSocialBtn1: "telegram channel",
      footerSocialBtn3: "VK",

      footerInfoBtn1: "knowledge base",
      footerInfoBtn2: "about the data center",
      footerInfoBtn3: "referral program",

      footerOtherBtn1: "brandbook",

      footerBottomInfo1: "QWINS Hosting, 2024. All rights reserved.",
      footerBottomInfo2: "Privacy Policy",
      footerBottomInfo3: "Terms Of Service",

      // Main Banner
      mainBannerHeader1: "Modern Cloud Hosting",
      mainBannerHeader2: "Provider",

      mainBannerDescr1:
        "Performance and reliability guarantee uninterrupted operation of high-",
      mainBannerDescr2:
        "availability projects. We offer dedicated resources and installation of any OS or",
      mainBannerDescr3: "ISO image.",

      mainBannerBtn: "view plans",

      // Pros Cards 1
      prosCard1Header1: "Modern equipment",
      prosCard1Header2: "Work at",
      prosCard1Header3: "Technical support",
      prosCard1Header4: "Reliability and availability",

      prosCard1Descr1:
        "We offer you reliable and efficient hosting that will ensure the stable operation of your project.",
      prosCard1Descr2:
        "If you rent a server, you can be sure that you will get full access to its resources.",
      prosCard1Descr3:
        "Our team is always ready to help you resolve any questions or disputes at any time of the day or night.",
      prosCard1Descr4:
        "Our team guarantees a high level of availability of all our services, which is at least 98% per year. This significantly reduces the risk of your project becoming unavailable.",

      // Minor Header 1
      minorHeader1: "A reliable platform for your projects",
      minorHeader1Descr1:
        "Our servers provide your business with the stability and reliability to meet even the most",
      minorHeader1Descr2: "demanding challenges.",

      // Pros Cards 2
      prosCards2Header1: "User-friendly control panel",
      prosCards2Header2: "Quick deployment",
      prosCards2Header3: "Powerful cloud computing",

      prosCards2Descr1:
        "Full control over your resources with an intuitive interface for efficient server management.",
      prosCards2Descr2:
        "Instant startup right after payment: Your server will be up and running in just 120 seconds.",
      prosCards2Descr3:
        "Optimized infrastructure provides high performance for projects of any size.",

      // Minor Header 2
      minorHeader2: "Purchase our services on Telegram",
      minorHeader2Descr1:
        "Just a few simple steps—and your server will be up and running!",

      // Guide Cards
      guideHeader1: "1. Start the bot by entering the command: /start",
      guideHeader2: "2. Choose a convenient payment method",
      guideHeader3: "3. Find a suitable server to purchase",
      guideHeader4_1: "Go to our",
      guideHeader4_2: "Telegram bot.",

      // Minor Header 3
      minorHeader3: "What do our customers think about us?",
      minorHeader3Descr1:
        "Here you can find feedback from clients who have used our services.",

      // Feedback Cards
      fdHeader1: "Narrator",
      fdHeader2: "brellan",
      fdHeader3: "caspSOFT",
      fdHeader4: "Narrator",
      fdHeader5: "brellan",

      fdDescr1:
        "This is not the first time we work with this hosting, everything is clear and fast, happy with the servers.",
      fdDescr2:
        "Used this hosting service more than once, everything always went smoothly and quickly.",
      fdDescr3:
        "The server was doing its job perfectly. Decided to renew my services in the future.",
      fdDescr4:
        "This is not the first time we work with this hosting, everything is clear and fast, happy with the servers.",
      fdDescr5:
        "Used this hosting service more than once, everything always went smoothly and quickly.",

      fdPlaceholder: "Customer review · ",

      // Questions Module
      qMinorHeader: "FAQ",

      qHeader1: "Trial period",
      qHeader2:
        "What is the difference between a virtual server and a dedicated server?",
      qHeader3: "DDoS Protection",
      qHeader4: "Virtualization",

      qDescr1:
        "Unfortunately, we cannot provide you with a test period. However, if for any reason the server is not suitable for you, we will gladly refund your money according to our service policy, except for promotional rates (DE-1, NL-1, FI-1 and EE-1), for which no refunds are available under any circumstances.",
      qDescr2:
        "A virtual server uses some of the resources of the physical server on which the virtual machine is running. You have full control over these resources, and they will not be used by other users of the physical server. A dedicated server, unlike a virtual server, uses 100% of the resources because it is a full physical machine.",
      qDescr3:
        "Our defense system integrates seamlessly with all cloud servers, with no additional configuration or fees required. It works continuously, effectively blocking attacks up to 2 Tbps. This system is suitable for any application, including game servers and high load internet projects. Trust us and you'll always be protected.",
      qDescr4:
        "All cloud servers are powered by KVM virtualization, which ensures that each server is completely isolated from the others. This gives you full access to the system core and firewall.",

      qCardHeader1: "Knowledge base",
      qCardHeader2: "Didn't find the answer to your question?",

      qCardDescr1: "Here we've compiled answers to the most common questions.",
      qCardDescr2: "Submit it to us via the control panel or in Telegram.",

      qCardLink1: "Go",
      qCardLink2: "Ask a question",

      // Data Center
      DCMainColHeader1: "location",
      DCMainColHeader2: "tier III",
      DCMainColHeader3: "reduced latency",
      DCMainColHeader4: "availability",

      DCMainColText1:
        "Am Kronberger Hang 6, 65824 Schwalbach am Taunus, Germany",
      DCMainColText2:
        "increased backup capacity and no downtime during maintenance.",
      DCMainColText3:
        "Thanks to connections to numerous internet exchange points, such as DEC-IX, NL-IX, 1-IX, and others.",
      DCMainColText4:
        "99.8% SLA is ensured through full redundancy of all systems.",

      DCFooter: "data center",

      DCCardHeader1: "Reliable Security System",
      DCCardHeader2: "Up to 2 Tbps Attack Protection",
      DCCardHeader3: "Geolocations",

      DCCardText1:
        "Various security measures are used in the data center, including video surveillance, biometric identification, and security alarms. Fire protection systems and enhanced security systems are also in place.",
      DCCardText2:
        "Our security system is equipped with cutting-edge technologies that detect and prevent any DDoS attacks. This minimizes the risk of network-level issues and ensures the stability of your services.",
      DCCardText3:
        "We provide services in 5 locations: Germany, Finland, the Netherlands, Estonia, and Russia.",

      DCMinorBannerText1:
        "With it, you can check server availability, assess connection speed",
      DCMinorBannerText2: "and perform real-time route tracing.",

      DCqHeader1: "How is server reliability ensured in the data center?",
      DCqHeader2:
        "What role does the data center location of the hosting provider play?",
      DCqHeader3: "What are the advantages of these data centers?",

      DCqText1:
        "Server reliability is achieved through redundancy of power sources, cooling systems, and internet channels. In case of issues, various measures are in place to ensure uninterrupted server operation.",
      DCqText2:
        "The location of data centers plays a key role in ensuring high server availability and fast response times. We carefully selected locations for our data centers to provide extensive geographic coverage and ensure instant access to servers for our clients worldwide.",
      DCqText3:
        "We chose these data centers because they comply with Tier III standards and offer a high level of security and reliability. Our data centers are equipped with a unique fire protection system, as well as enhanced security measures and high safety standards, including access control, video surveillance, and alarm systems.",

      // Virtual Servers Page
      VSMainBannerHeader: "Virtual Servers",
      VSMainBannerText1: "Virtual servers equipped with powerful",
      VSMainBannerText2: " AMD processors and fast",
      VSMainBannerText3: " NVMe SSD storage.",
      size: "Disk Space",
      ddos: "DDoS Protection",
      ram: "RAM",
      vcpu: "vCPU",
      networks: "Networks",
      speed: "Port speed",

      OSHeader1: "Operating ",
      OSHeader2: "systems",
      OSText: "We'll find exactly what you need.",

      VSCountryCardsPrice1_1: "2 $ /month",
      VSCountryCardsPrice1_2: "3.84 $ /month",
      VSCountryCardsPrice1_3: "3.84 $ /month",
      VSCountryCardsPrice1_4: "3.84 $ /month",

      VSCountryCardsRAM1_1: "1 GB",
      VSCountryCardsRAM1_2: "1 GB",
      VSCountryCardsRAM1_3: "1 GB",
      VSCountryCardsRAM1_4: "1 GB",

      VSCountryCardsSize1_1: "10 GB",
      VSCountryCardsSize1_2: "10 GB",
      VSCountryCardsSize1_3: "10 GB",
      VSCountryCardsSize1_4: "10 GB",

      VSCountryCardsDDOS1_1: "2 Tbps",
      VSCountryCardsDDOS1_2: "2 Tbps",
      VSCountryCardsDDOS1_3: "2 Tbps",
      VSCountryCardsDDOS1_4: "2 Tbps",

      VSCountryCardsPrice2_1: "2 $ /month",
      VSCountryCardsPrice2_2: "3.84 $ /month",
      VSCountryCardsPrice2_3: "3.84 $ /month",
      VSCountryCardsPrice2_4: "3.84 $ /month",

      VSCountryCardsRAM2_1: "1 GB",
      VSCountryCardsRAM2_2: "1 GB",
      VSCountryCardsRAM2_3: "1 GB",
      VSCountryCardsRAM2_4: "1 GB",

      VSCountryCardsSize2_1: "10 GB",
      VSCountryCardsSize2_2: "10 GB",
      VSCountryCardsSize2_3: "10 GB",
      VSCountryCardsSize2_4: "10 GB",

      VSCountryCardsDDOS2_1: "2 Tbps",
      VSCountryCardsDDOS2_2: "2 Tbps",
      VSCountryCardsDDOS2_3: "2 Tbps",
      VSCountryCardsDDOS2_4: "2 Tbps",

      VSMinorHeader: "Why choose our servers?",
      VSMinorHeaderText: "We strive to be perfect in everything",

      VSSwitchBtn1: "Germany",
      VSSwitchBtn2: "Finland",
      VSSwitchBtn3: "Netherlands",
      VSSwitchBtn4: "Russia",
      VSSwitchBtn5: "Estonia",

      VSBuyBtnText: "Order",

      VSProsHeader1: "SuperHardware!",
      VSProsHeader2: "Virtual is real",
      VSProsHeader3: "Technical support",
      VSProsHeader4: "Backup",
      VSProsHeader5: "Extreme speed",
      VSProsHeader6: "Disks",
      VSProsHeader7: "Your server – your rules",
      VSProsHeader8: "Full control",
      VSProsHeader9: "Ready in a snap",

      VSProsText1:
        "We use only our own, reliable, latest-generation hardware from leading global manufacturers.",
      VSProsText2:
        "Our servers are based on KVM technology, which provides full emulation of individual computer components: processor, RAM, disk drive and network interface.",
      VSProsText3:
        "We are always ready to help when you have technical questions, any time of the day or night. We will be happy to support you and do our best to solve your problems.",
      VSProsText4:
        "For each of the virtual servers you can activate the backup service for 20% of the server price for a month.",
      VSProsText5:
        "Our servers run on ports with speeds of 1–10 Gbps. Your websites will load almost instantly. No. Instantly.",
      VSProsText6_1:
        "We exclusively use Datacenter NVMe drives, which provide high reliability and incredible read and write speeds.",
      VSProsText6_2: "",
      VSProsText7:
        "Choose any operating system you are comfortable working with. We will install it on your server.",
      VSProsText8:
        "We offer a wide range of control panels, including free options. Choose the most suitable one for you and manage your server with administrator rights.",
      VSProsText9:
        "Once you order and pay for a virtual server, it will be provided to you in just 120 seconds. The process is carried out in automatic mode.",

      VSMinorBannerHeader: "Direct connection up to 10 Gbps",
      VSMinorBannerHeaderText_1:
        "Each client, in addition to connections to major operators, traffic exchange points, and",
      VSMinorBannerHeaderText_2:
        "ISPs, receives a dedicated channel for their server with speeds up to 10 Gbps.",
      VSMinorBannerHeaderText_3:
        "This ensures high-speed data transfer between the client and the server.",

      DSMinorBannerHeader: "Direct connection up to 1 Gbps",
      DSMinorBannerHeaderText_1:
        "Each client, in addition to connections to major operators, traffic exchange points, and",
      DSMinorBannerHeaderText_2:
        "ISPs, receives a dedicated channel for their server with speeds up to 1 Gbps.",
      DSMinorBannerHeaderText_3:
        "This ensures high-speed data transfer between the client and the server.",

      DSMainBannerHeader: "Dedicated Servers",
      DSMainBannerText1: "High-bandwidth dedicated servers are the ideal",
      DSMainBannerText2: "solution for projects that require a powerful",
      DSMainBannerText3: "infrastructure.",

      RMainBanner1: "Brand resources",
      RMainBanner2: "Thanks for being with us",
      RMinorHeader1: "Avatar",
      RMinorHeader2: "Colors",
      RMinorHeader3: "Logo",

      // Privacy Page
      PPMainBlockContent: [
        {
          header: "General Provisions",
          items: [
            "This personal data processing policy defines the procedure for processing personal data and measures to ensure the security of personal data by the QWINS Hosting service (hereinafter referred to as the Operator).",
            "The Operator considers compliance with human rights and freedoms in the processing of personal data, including the right to privacy, personal and family secrets, as one of the most important goals and conditions of its activities.",
            "This Operator’s policy regarding the processing of personal data (hereinafter referred to as the Policy) applies to all information that the Operator may receive about visitors to the website https://qwins.co.",
          ],
        },
        {
          header: "Awareness of GDPR",
          items: [
            "The Operator acknowledges that it is obligated to comply with the General Data Protection Regulation (GDPR) with respect to citizens and residents of the European Union.",
            "Data subject rights: In accordance with the GDPR, users have the following rights:",
            "The right to access their personal data.",
            "The right to rectify inaccurate or incomplete data.",
            "The right to erase personal data ('right to be forgotten').",
            "The right to restrict the processing of personal data.",
            "The right to data portability.",
            "The right to object to the processing of personal data.",
            "Consent: The Operator processes Users’ personal data based on explicit consent provided by the User, particularly for marketing purposes.",
            "Data transfer: Cross-border transfer of personal data will be carried out only to countries that ensure an adequate level of data protection or under standard contractual clauses approved by the European Commission.",
            "Contact information for GDPR-related questions and complaints: Users can contact help@qwins.co for data protection and GDPR-related issues.",
            "Policy updates: The Operator regularly reviews and updates this policy to ensure its compliance with the current GDPR requirements.",
          ],
        },
        {
          header:
            "The Operator May Process the Following Personal Data of the User",
          items: [
            "Surname, first name, patronymic;",
            "Email address;",
            "Phone number;",
            "Identity document details;",
            "IP address;",
            "The website also collects and processes anonymized data about visitors (including cookies) through web analytics services (Google Analytics and others).",
            "The above data is collectively referred to as personal data in this policy.",
          ],
        },
        {
          header: "Purposes of Personal Data Processing",
          items: [
            "Informing the user by sending emails;",
            "Providing the user with access to services, information, and/or materials on the website;",
            "Contacting the user via the provided contact details;",
            "Providing services to the user;",
            "User identification;",
            "Ensuring user security;",
            "The Operator has the right to send the user notifications about new products and services, special offers, and various events.",
            "The user can always opt out of receiving informational messages by sending an email to help@qwins.co with the subject 'Unsubscribe from notifications about new products, services, and special offers.'",
            "Anonymized user data collected via web analytics services is used to gather information about user behavior on the site and improve the quality and content of the site.",
            "Personal data may be used for client identification and for operations requiring identification.",
          ],
        },
        {
          header:
            "Procedure for Collection, Storage, Transfer, and Other Processing of Personal Data",
          items: [
            "The security of personal data processed by the Operator is ensured through legal, organizational, and technical measures necessary to fully comply with current legislation on personal data protection.",
            "The Operator ensures the confidentiality of personal data and takes all possible measures to prevent unauthorized access to personal data.",
            "Personal data will never, under any circumstances, be transferred to third parties, except as required by applicable law.",
            "If inaccuracies are found in the personal data, the User may update them by sending a notification to the Operator's email address: help@qwins.co with the subject 'Update of personal data'.",
            "The processing period for personal data is unlimited.",
            "The user may withdraw their consent to the processing of personal data at any time by sending a notification to the Operator’s email address help@qwins.co with the subject 'Withdrawal of consent to personal data processing'.",
          ],
        },
        {
          header: "Cross-Border Transfer of Personal Data",
          items: [
            "Before carrying out the cross-border transfer of personal data, the Operator must ensure that the foreign country to which the data is to be transferred provides reliable protection of the rights of data subjects.",
            "Cross-border transfer of personal data to countries that do not meet the above requirements may only be carried out with the written consent of the data subject and/or for the execution of a contract to which the data subject is a party.",
          ],
        },
        {
          header: "Final Provisions",
          items: [
            "The user can obtain any clarifications on matters of interest regarding the processing of their personal data by contacting the Operator via email at help@qwins.co.",
            "Any changes to the Operator’s personal data processing policy will be reflected in this document. The policy is valid indefinitely until replaced by a new version.",
            "The current version of the policy is freely available on the Internet at https://qwins.co/privacy.",
          ],
        },
      ],

      PPNavigationHeader: "Navigation",
      PPPrivacyHeader: "Privacy Policy",

      TPMainBlockContent: [
        {
          header: "Zone of responsibility of the company",
          items: [
            "Problems with host machines and communication – responsibility of the company.",
            "Problems with the operating system or any software installed on the virtual server by the client – responsibility of the client.",
          ],
        },
        {
          header: "Payment procedure",
          items: [
            "Payment for the company's services by the client is made on a 100% prepayment basis.",
            "Services are provided within 24 hours after payment, unless otherwise specified.",
            "The service is considered fully provided to the client from the moment the client is granted access to the service. No other moment can be considered as the moment when the company fulfills its obligations.",
            "Payment by individuals is made only via electronic payments.",
            "Hosting payment is made in dollars according to the current rates published on the official company website at: https://qwins.co",
            "A commission from intermediaries and payment systems may be added to the payment.",
            "If payment for the next hosting period is not made, the company suspends service provision.",
            "After the paid period ends, data is retained for up to 8 (eight) hours. After this period, all client data related to the provided service may be deleted without the possibility of recovery.",
            "If full payment is received after the service has been suspended, service restoration will occur within 24 (twenty-four) hours, unless otherwise specified.",
          ],
        },
        {
          header: "Refund policy",
          items: [
            "The client has the right to receive a refund for advance payments (payments) from the balance in the personal account, if the total amount is no less than $40.",
            "The client has the right to receive a refund for an activated service (hosting) if no more than 24 hours have passed since activation, excluding promo tariffs DE-1 / FI-1 / NL-1 and EE-1, but no more than 50% of the service cost.",
            "Refunds are made using the same payment method and to the same card (wallet) that was used for the payment.",
            "To request a refund, a request must be created in the support section of the personal account at https://my.qwins.co.",
            "The refund request will be processed within 7 business days from the receipt of the request from the client. The time it takes for the funds to arrive depends on the client’s bank or wallet.",
            "In case of the client violating this user agreement and/or proven fraudulent actions by the client, the company has the right to refuse a refund.",
            "If the company has incurred losses due to the client's fault, the amount of the refund may be reduced by the costs incurred by the company.",
          ],
        },
        {
          header: "Client rights and obligations",
          items: [
            "The client is granted access (unless otherwise specified) to the server and bears all associated responsibility.",
            "The client has the right to install and use any software on their server, provided that it is legal and does not violate copyright and related rights, as well as the current legislation of the United Kingdom.",
            "The client is obligated to ensure that all materials hosted, software used, and content uploaded to the server comply with the current legislation of the United Kingdom.",
            "The client has the right to use the hosting for any purpose, except for purposes that contradict the legislation of the United Kingdom and copyright laws.",
            "All issues related to the functionality of the client's hosting are accepted only in requests for support in the personal account at https://my.qwins.co.",
            "If the client's hosting is blocked due to complaints and/or other reasons (network scan, outgoing DoS attacks, etc.) and the client does not take action regarding the complaint, the company has the right to terminate the service and block the client without a refund.",
            "The client has the right to sign an act of rendered services within 2 (two) business days after receiving the services or to provide a written reasoned refusal to sign the act.",
            "If the client does not sign the act or send the company a reasoned objection within 2 (two) business days after the service has been provided, the act is considered signed by the client. In this case, the services are considered to have been provided by the company in full and no additional documents are required.",
          ],
        },
        {
          header: "Company rights and obligations",
          items: [
            "The company's services are provided 'as is,' and the company reserves the right to revise the service provision rules, including the pricing policy and tariff specifications, at any time without prior notice and unilaterally. The new rules come into effect upon publication on the official website.",
            "The company is obligated to maintain the proper quality of host machines and promptly address any faults.",
            "The company is obligated to notify about planned maintenance via email to the client's address. This does not apply to force majeure situations and unplanned work.",
            "The company is not responsible for service unavailability due to third-party actions.",
            "The company reserves the right to suspend services and servers for scheduled maintenance, due to DoS and network attacks, natural disasters, and other force majeure circumstances.",
            "The company provides technical support services to clients based on client requests through the personal account according to the rates published on the official company website at https://qwins.co.",
            "The company is not responsible for third-party software on the company's servers, including software purchased through the company.",
            "The company is not liable to users or any third parties for any damage, including lost profits, caused by the use of the company's services.",
          ],
        },
        {
          header: "Prohibited content and software",
          items: [
            "Pornography, including links and advertisements containing pornographic scenes, is prohibited on the hosting.",
            "Placing information and software that contradicts and/or is prohibited by the laws of the United Kingdom and copyright law is prohibited.",
            "Placing software for botnets, grabbing, phishing, and other activities clearly contrary to legal operation on the Internet is prohibited.",
            "Mass mailing is prohibited unless authorized by the company.",
            "Placing services (including paid or private access) that could be used as tools for illegal activities on the Internet is prohibited.",
            "Placing network scanners, proxy checkers, and similar software is prohibited.",
            "Cryptocurrency mining and related activities are prohibited.",
          ],
        },
        {
          header: "Termination of services by the company's initiative",
          items: [
            "The company reserves the right to terminate services at its discretion, immediately and without warning in the case of:",
            "Unauthorized distribution or copying of copyrighted software, violation of UK laws, international norms and agreements, export restrictions, fraud, circulation of pornography, drugs, and other illegal activities.",
            "Mass mailing of unsolicited emails.",
            "Defamation, dissemination of personal information, violations of copyright and intellectual property rights.",
            "Posting of pornographic content in all its forms, including links to websites with pornographic content.",
            "Violations of privacy and property rights, posting defamatory and offensive information, inciting or supporting racial hatred, murder, terrorism, or violence in any form.",
            "Interference with the normal and stable operation of the company's servers, network resources, and overall infrastructure.",
            "Providing deliberately false client data or refusal to verify such data.",
            "Inappropriate communication with the company's employees, including the use of profanity and the dissemination of defamatory information about the company.",
            "The company reserves the right to transfer client information upon official request by law enforcement authorities.",
          ],
        },
        {
          header: "Company is not responsible",
          items: [
            "For the client's choice of operating system, software, or any consequences that may result from it, including complete data loss. We bear no responsibility for the data stored on your server",
            "For any types of direct or indirect damage, loss of information, business reputation, or any other damages.",
            "The company does not check the content hosted on the client's hosting. Exceptions are cases of motivated complaints from third parties.",
          ],
        },
        {
          header: "Service level guarantee",
          items: [
            "The company guarantees a hosting server availability level of 98% per month.",
            "In case of violation of item 9.1 of this agreement, each full day (24 hours) of service downtime will be compensated to the client at double the service duration.",
            "Compensation is given in the form of additional service days and cannot be paid in monetary terms.",
            "Compensation is credited based on a request submitted to support in the personal account at https://my.qwins.co.",
          ],
        },
        {
          header: "Email notifications",
          items: [
            "Client registration in the personal account at https://my.qwins.co implies automatic consent to receive informational email messages, including offers from the company.",
            "Refusal to receive notifications is only possible if the client's account is completely closed.",
            "The company is not responsible for the client not receiving important informational messages via email.",
          ],
        },
      ],
      TPNavigationHeader: "Navigation",
      TPPrivacyHeader: "Terms of service",

      // Referral Page
      RPMainBannerHeader: "Referral Program",
      RPMainBannerText1:
        "An exclusive referral program for our valued clients,",
      RPMainBannerText2: "that enables you to earn real money.",
      RPMainBannerBtn: "Become a Partner",

      RPProsHeader1: "Affiliate percentage",
      RPProsHeader2: "Passive Income",

      RPProsText1:
        "Refer customers to our hosting service by telling them about us online. When a user you invite registers an account through your referral link and orders any of our services, you will receive 5% of their spend.",
      RPProsText2:
        "To ensure a stable income, you need to attract a client who will actively use our services. The longer they stay with us and the more services they use, the more income you will earn.",

      RPNotifHeader: "Referral Program",
      RPNotifText: "You’ve received a cash reward",

      RPTextBlock1:
        "1. Do not use spam mailings related to QWINS Hosting to attract clients. Also, do not spread inaccurate information about our services, such as quoting prices that do not reflect reality.",
      RPTextBlock2:
        "2. The referral program is valid indefinitely. Once you invite a new client and they pay for any service, you will receive 5% of all their purchases—even five years later.",
      RPTextBlock3:
        "3. Funds earned through the referral program are automatically credited after the client orders a service. You can request withdrawal on the same day.",
      RPTextBlock4:
        "4. If a client violates the referral program rules, payments may be canceled without prior notice.",

      // Tariffs
      // dedicated page
      DPGer: [
        {
          header: "i7-6700",
          price: "$55 per month",
          cpu: "Intel Core i7-6700",
          vcpu: "x 8",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i7-7700",
          price: "$55 per month",
          cpu: "Intel Core i7-7700",
          vcpu: "x 8",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i7-8700",
          price: "$60 per month",
          cpu: "Intel Core i7-8700",
          vcpu: "x 12",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "E3-1275v6",
          price: "$60 per month",
          cpu: "Intel Xeon E3-1275v6",
          vcpu: "x 12",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R5-3600",
          price: "$70 per month",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 12",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R5-3600",
          price: "$80 per month",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 12",
          ram: "128 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i9-9900K",
          price: "$100 per month",
          cpu: "Intel Core i9-9900K",
          vcpu: "x 16",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i5-13500",
          price: "$80 per month + $50 setup fee",
          cpu: "Intel Core i5-13500",
          vcpu: "x 20",
          ram: "64 GB",
          size: "2×512 GB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i9-13900",
          price: "$155 per month + $50 setup fee",
          cpu: "Intel Core i9-13900",
          vcpu: "x 32",
          ram: "64 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i9-13900",
          price: "$175 per month + $50 setup fee",
          cpu: "Intel Core i9-13900",
          vcpu: "x 32",
          ram: "128 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$95 per month",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 3900",
          price: "$100 per month",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "64 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 3900",
          price: "$150 per month",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 5950X",
          price: "$150 per month",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "128 GB",
          size: "2×3.84 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502",
          price: "$200 per month",
          cpu: "AMD EPYC 7502",
          vcpu: "x 64",
          ram: "128 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$220 per month",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "128 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$300 per month",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "256 GB",
          size: "1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$420 per month",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "512 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$700 per month",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "1024 GB",
          size: "3.84 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i9-12900K",
          price: "$180 per month",
          cpu: "Intel Core i9-12900K",
          vcpu: "x 24",
          ram: "128 GB",
          size: "4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 9454P",
          price: "$300 per month + $110 setup fee",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "128 GB",
          size: "2×4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 9454P",
          price: "$300 per month + $110 setup fee",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "256 GB",
          size: "2×4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 9454P",
          price: "$600 per month + $110 setup fee",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "512 GB",
          size: "2×4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 9454P",
          price: "$1000 per month + $110 setup fee",
          cpu: "AMD EPYC 9454P",
          vcpu: "x 96",
          ram: "1024 GB",
          size: "4×4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 7950X",
          price: "$145 per month + $50 setup fee",
          cpu: "AMD Ryzen 9 7950X",
          vcpu: "x 32",
          ram: "128 GB",
          size: "2×2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 PRO 8700 GE",
          price: "$80 per month + $50 setup fee",
          cpu: "AMD R7 PRO 8700 GE",
          vcpu: "x 16",
          ram: "64 GB",
          size: "2×512 GB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 PRO 8700 GE",
          price: "$110 per month + $50 setup fee",
          cpu: "AMD R7 PRO 8700 GE",
          vcpu: "x 16",
          ram: "128 GB",
          size: "2×512 GB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 7700",
          price: "$100 per month + $50 setup fee",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "64 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 7700",
          price: "$130 per month + $50 setup fee",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i5-13500",
          price: "$105 per month + $50 setup fee",
          cpu: "Intel Core i5-13500",
          vcpu: "x 20",
          ram: "128 GB",
          size: "2×512 GB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 7700",
          price: "$150 per month + $50 setup fee",
          cpu: "AMD Ryzen 7 7700",
          vcpu: "x 16",
          ram: "192 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$220 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "128 GB",
          size: "2×3.84 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$220 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "256 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$350 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "384 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$450 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "512 GB",
          size: "3×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$600 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "768 GB",
          size: "4×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i7-6700",
          price: "$65 per month",
          cpu: "Intel Core i7-6700",
          vcpu: "x 8",
          ram: "32 GB",
          size: "2×4 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i7-8700",
          price: "$120 per month",
          cpu: "Intel Core i7-8700",
          vcpu: "x 12",
          ram: "64 GB",
          size: "2×6 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i7-8700",
          price: "$160 per month",
          cpu: "Intel Core i7-8700",
          vcpu: "x 12",
          ram: "64 GB",
          size: "2×8 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$160 per month",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 GB",
          size: "2×12 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$200 per month",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 GB",
          size: "2×16 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$160 per month",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 GB",
          size: "16 TB + 2×8 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R5-3600",
          price: "$250 per month",
          cpu: "AMD Ryzen 5 3600",
          vcpu: "x 16",
          ram: "64 GB",
          size: "4×16 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$330 per month",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "128 GB",
          size: "10×16 TB HDD + 2×1 TB SSD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "W-2145",
          price: "$330 per month",
          cpu: "Intel Xeon W-2145",
          vcpu: "x 16",
          ram: "128 GB",
          size: "10×16 TB HDD + 2×1 TB SSD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R7 3700X",
          price: "$275 per month + $60 setup fee",
          cpu: "AMD Ryzen 7 3700X",
          vcpu: "x 16",
          ram: "64 GB",
          size: "4×22 TB HDD + 2×1 TB NVMe",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 3900",
          price: "$390 per month + $110 setup fee",
          cpu: "AMD Ryzen 9 3900",
          vcpu: "x 24",
          ram: "128 GB",
          size: "8×22 TB HDD + 2×2 TB NVMe",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$600 per month + $110 setup fee",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "256 GB",
          size: "14×22 TB HDD + 2×8 TB NVMe",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$690 per month + $110 setup fee",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "512 GB",
          size: "14×22 TB HDD + 2×8 TB NVMe",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EPYC 7502P",
          price: "$1000 per month + $110 setup fee",
          cpu: "AMD EPYC 7502P",
          vcpu: "x 64",
          ram: "1024 GB",
          size: "14×22 TB HDD + 2×8 TB NVMe",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "i5-12500",
          price: "$300 per month + $110 setup fee",
          cpu: "Intel Core i5-12500",
          vcpu: "x 12",
          ram: "128 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 5412U",
          price: "$1300 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 5412U",
          vcpu: "x 48",
          ram: "128 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$520 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "128 GB",
          size: "1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$620 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "256 GB",
          size: "2×1.92 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$750 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "512 GB",
          size: "2×3.84 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$820 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "768 GB",
          size: "2×3.84 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$950 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "1024 GB",
          size: "7.68 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$1200 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "1536 GB",
          size: "2×7.68 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon Gold 6438Y+",
          price: "$1550 per month + $110 setup fee",
          cpu: "Intel Xeon Gold 6438Y+",
          vcpu: "x 128",
          ram: "2048 GB",
          size: "2×7.68 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
      ],
      DPNet: [
        {
          header: "Xeon E3-12xx",
          price: "$100 per month",
          cpu: "Intel Xeon E3-12xx",
          vcpu: "x 8",
          ram: "32 GB",
          size: "8 TB HDD",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 5950X",
          price: "$170 per month",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 5950X",
          price: "$195 per month",
          cpu: "AMD Ryzen 9 5950X",
          vcpu: "x 32",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Xeon E3-12xx",
          price: "$120 per month",
          cpu: "Intel Xeon E3-12xx",
          vcpu: "x 8",
          ram: "32 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x Intel Xeon E5-2680v4",
          price: "$200 per month",
          cpu: "2x Intel Xeon E5-2680v4",
          vcpu: "x 56",
          ram: "128 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x AMD EPYC 7551",
          price: "$355 per month",
          cpu: "2x AMD EPYC 7551",
          vcpu: "x 128",
          ram: "256 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x AMD EPYC 7551",
          price: "$385 per month",
          cpu: "2x AMD EPYC 7551",
          vcpu: "x 128",
          ram: "256 GB",
          size: "4 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x AMD EPYC 7451",
          price: "$250 per month",
          cpu: "2x AMD EPYC 7451",
          vcpu: "x 96",
          ram: "256 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "R9 7950X",
          price: "$260 per month",
          cpu: "AMD Ryzen 9 7950X",
          vcpu: "x 32",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M2",
          price: "$200 per month",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "8 GB",
          size: "256 GB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M1",
          price: "$300 per month",
          cpu: "Apple M1",
          vcpu: "x 8",
          ram: "16 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M2",
          price: "$400 per month",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "16 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M2 Pro",
          price: "$500 per month",
          cpu: "Apple M2 Pro",
          vcpu: "x 12",
          ram: "16 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M2",
          price: "$600 per month",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "32 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Apple M2",
          price: "$800 per month",
          cpu: "Apple M2",
          vcpu: "x 8",
          ram: "64 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "Intel Core i7. MacOS server",
          price: "$350 per month",
          cpu: "Intel Core i7",
          vcpu: "x None",
          ram: "64 GB",
          size: "1 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
      ],
      DPRus: [
        {
          header: "2x Intel Xeon E5-2697A v4",
          price: "200$ per month",
          cpu: "2x Intel Xeon E5-2697A v4",
          vcpu: "x 64",
          ram: "256 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x Intel Xeon Gold 6148",
          price: "350$ per month",
          cpu: "2x Intel Xeon Gold 6148",
          vcpu: "x 80",
          ram: "256 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "2x Intel Xeon E5-2470 v2",
          price: "150$ per month",
          cpu: "2x Intel Xeon E5-2470 v2",
          vcpu: "x 40",
          ram: "384 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "AMD Ryzen 9 5950X",
          price: "200$ per month",
          cpu: "2x Intel Xeon E5-2470 v2",
          vcpu: "x 40",
          ram: "128 GB",
          size: "2 TB",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
        {
          header: "AMD Ryzen 9 5950X",
          price: "350$ per month",
          cpu: "2x Intel Xeon E5-2470 v2",
          vcpu: "x 40",
          ram: "128 GB",
          size: "2 TB",
          gpu: "RTX 3070 TI",
          networks: "",
          speed: "",
          ddos: "up to 2 Tbps",
        },
      ],

      // Virtual Page
      VPGer: [
        {
          header: "DE-1 without technical support",
          price: "$2 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 1",
          ram: "1 GB",
          size: "10 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 100 Mbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-2",
          price: "$3.84 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 1",
          ram: "2 GB",
          size: "30 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-3",
          price: "$6.58 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 2",
          ram: "4 GB",
          size: "60 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-4",
          price: "$9 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 3",
          ram: "6 GB",
          size: "75 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-5",
          price: "$13.16 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 4",
          ram: "8 GB",
          size: "90 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-6",
          price: "$17.55 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 6",
          ram: "12 GB",
          size: "120 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-7",
          price: "$21.93 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 8",
          ram: "16 GB",
          size: "160 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-8",
          price: "$38.39 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 8",
          ram: "32 GB",
          size: "240 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-9",
          price: "$42 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 12",
          ram: "24 GB",
          size: "280 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-10",
          price: "$45 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 14",
          ram: "28 GB",
          size: "300 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-11",
          price: "$50 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 16",
          ram: "32 GB",
          size: "320 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-12",
          price: "$60 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 18",
          ram: "36 GB",
          size: "340 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-13",
          price: "$65.80 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 12",
          ram: "48 GB",
          size: "360 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-14",
          price: "$72 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 20",
          ram: "38 GB",
          size: "390 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-15",
          price: "$85 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 22",
          ram: "44 GB",
          size: "410 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-16",
          price: "$89.93 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 16",
          ram: "64 GB",
          size: "440 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-17",
          price: "$95 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 24",
          ram: "48 GB",
          size: "470 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-18",
          price: "$115 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 28",
          ram: "50 GB",
          size: "500 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-19",
          price: "$130 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 30",
          ram: "52 GB",
          size: "530 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-20",
          price: "$150 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 32",
          ram: "64 GB",
          size: "560 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "DE-21",
          price: "$200 per month",
          cpu: "AMD Ryzen 9 7950X3D",
          vcpu: "x 32",
          ram: "128 GB",
          size: "1024 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 1 Gbps",
          ddos: "up to 2 Tbps",
        },
      ],
      VPFin: [
        {
          header: "FI-1 without technical support",
          price: "$2 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "1 GB",
          size: "10 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 100 mbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-2",
          price: "$3.84 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "2 GB",
          size: "30 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-3",
          price: "$6.58 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 2",
          ram: "4 GB",
          size: "60 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-4",
          price: "$9 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 3",
          ram: "6 GB",
          size: "75 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-5",
          price: "$13.16 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 4",
          ram: "8 GB",
          size: "90 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-6",
          price: "$13.16 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 6",
          ram: "12 GB",
          size: "120 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-7",
          price: "$21.93 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "16 GB",
          size: "160 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-8",
          price: "$38.39 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "32 GB",
          size: "240 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-9",
          price: "$42 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "24 GB",
          size: "240 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-10",
          price: "$45 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 14",
          ram: "28 GB",
          size: "300 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-11",
          price: "$50 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "32 GB",
          size: "320 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-12",
          price: "$60 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 18",
          ram: "36 GB",
          size: "340 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-13",
          price: "$65.80 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "48 GB",
          size: "360 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-14",
          price: "$72 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 20",
          ram: "38 GB",
          size: "390 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-15",
          price: "$85 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 22",
          ram: "44 GB",
          size: "410 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-16",
          price: "$89.93 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "64 GB",
          size: "440 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-17",
          price: "$95 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 24",
          ram: "48 GB",
          size: "470 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-18",
          price: "$115 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 28",
          ram: "50 GB",
          size: "500 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-19",
          price: "$130 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 30",
          ram: "52 GB",
          size: "530 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-20",
          price: "$150 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "64 GB",
          size: "560 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
        {
          header: "FI-21",
          price: "$200 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "128 GB",
          size: "1024 GB",
          networks: "x 1 IPv4 and /64 IPv6.",
          speed: "up to 10 gbit/s.",
          ddos: "up to 2 tbps.",
        },
      ],
      VPNet: [
        {
          header: "NL-1 without technical support",
          price: "$2 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 1",
          ram: "1 GB",
          size: "10 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 100 Mbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-2",
          price: "$3.84 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 1",
          ram: "2 GB",
          size: "30 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-3",
          price: "$6.58 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 2",
          ram: "4 GB",
          size: "60 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-4",
          price: "$9 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 3",
          ram: "6 GB",
          size: "75 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-5",
          price: "$13.16 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 4",
          ram: "8 GB",
          size: "90 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-6",
          price: "$17.55 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 6",
          ram: "12 GB",
          size: "120 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-7",
          price: "$21.93 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 8",
          ram: "16 GB",
          size: "160 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-8",
          price: "$38.39 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 8",
          ram: "32 GB",
          size: "240 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-9",
          price: "$42 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 12",
          ram: "24 GB",
          size: "280 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-10",
          price: "$45 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 14",
          ram: "28 GB",
          size: "300 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-11",
          price: "$50 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 16",
          ram: "32 GB",
          size: "320 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-12",
          price: "$60 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 18",
          ram: "36 GB",
          size: "340 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-13",
          price: "$65.80 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 12",
          ram: "48 GB",
          size: "360 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-14",
          price: "$72 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 20",
          ram: "38 GB",
          size: "390 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-15",
          price: "$85 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 22",
          ram: "44 GB",
          size: "410 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-16",
          price: "$89.93 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 16",
          ram: "64 GB",
          size: "440 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-17",
          price: "$95 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 24",
          ram: "48 GB",
          size: "470 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-18",
          price: "$115 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 28",
          ram: "50 GB",
          size: "500 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-19",
          price: "$130 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 30",
          ram: "52 GB",
          size: "530 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-20",
          price: "$150 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 32",
          ram: "64 GB",
          size: "560 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "NL-21",
          price: "$200 per month",
          cpu: "AMD EPYC 7702",
          vcpu: "x 32",
          ram: "128 GB",
          size: "1024 GB",
          networks: "x IPv4 and /64 IPv6",
          speed: "100 Mbps",
          ddos: "up to 2 Tbps",
        },
      ],
      VPEst: [
        {
          header: "EE-1 without technical support",
          price: "$2 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "1 GB",
          size: "10 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 100 Mbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-2",
          price: "$3.84 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 1",
          ram: "2 GB",
          size: "30 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-3",
          price: "$6.58 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 2",
          ram: "4 GB",
          size: "60 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-4",
          price: "$9 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 3",
          ram: "6 GB",
          size: "75 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-5",
          price: "$13.16 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 4",
          ram: "8 GB",
          size: "90 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-6",
          price: "$17.55 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 6",
          ram: "12 GB",
          size: "120 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-7",
          price: "$21.93 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "16 GB",
          size: "160 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-8",
          price: "$38.39 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 8",
          ram: "32 GB",
          size: "240 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-9",
          price: "$42 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "24 GB",
          size: "280 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-10",
          price: "$45 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 14",
          ram: "28 GB",
          size: "300 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-11",
          price: "$50 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "32 GB",
          size: "320 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-12",
          price: "$60 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 18",
          ram: "36 GB",
          size: "340 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-13",
          price: "$65.80 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 12",
          ram: "48 GB",
          size: "360 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-14",
          price: "$72 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 20",
          ram: "38 GB",
          size: "390 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-15",
          price: "$85 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 22",
          ram: "44 GB",
          size: "410 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-16",
          price: "$89.93 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 16",
          ram: "64 GB",
          size: "440 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-17",
          price: "$95 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 24",
          ram: "48 GB",
          size: "470 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-18",
          price: "$115 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 28",
          ram: "50 GB",
          size: "500 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-19",
          price: "$130 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 30",
          ram: "52 GB",
          size: "530 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-20",
          price: "$150 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "64 GB",
          size: "560 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
        {
          header: "EE-21",
          price: "$200 per month",
          cpu: "Intel Xeon E5-2699v4",
          vcpu: "x 32",
          ram: "128 GB",
          size: "1024 GB",
          networks: "x 1 IPv4 and /64 IPv6",
          speed: "up to 10 Gbps",
          ddos: "up to 2 Tbps",
        },
      ],
      VHTariffs: [
        {
          header: "5 GB",
          price: "$5 per month",
          text: [
            "Control Panel: ISPmanager 6.",
            "Support for Python and NodeJS.",
            "Location: Germany.",
          ],
          tariff: [
            "50% vCore from Intel Xeon E-2276G.",
            "1 GB RAM.",
            "5 GB SSD storage and an additional $1 for every 5 GB of storage.",
            "Unlimited websites.",
            "Unlimited traffic.",
            "Unlimited number of databases.",
          ],
        },
      ],
      VHMainHeader: "Virtual Hosting",
      VHMainText1: "Virtual hosting with PHP and MySQL for websites ",
      VHMainText2: "of any complexity: from personal pages to ",
      VHMainText3: "high-traffic projects.",

      VHProsHeader1: "Storage Drives",
      VHProsHeader2: "Equipment",
      VHProsHeader3: "Scalability",

      VHProsText1:
        "We use SSD drives to ensure high operational speed and instant access to information without delays.",
      VHProsText2:
        "We employ reliable, tested hardware that meets all standards, so our clients can work without any issues.",
      VHProsText3:
        "We offer a single virtual hosting plan that can be easily adjusted and expanded if needed.",
      VHMinorHeader: "Tariff Plan",
      VHTariffHeader: "The tariff includes:",

      okakHeader: "PAGE NOT WORKING",
      okakText: "Not sure what's wrong, but we’ll fix it soon.",
      provider: "Hosting provider QWINS. All rights reserved.",
      okakButton: "GO TO HOMEPAGE",
      gpu: "GPU",
    },
  };

  // функция для получения перевода по ключу
  const t = (key) => {
    return translations[lang]?.[key] ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

// 4) Хук для доступа к текущему языку и переводчику
export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLang must be used within a LanguageProvider");
  }
  return ctx; // { lang, changeLang, t }
}
